(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6ccb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6ccb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lN1ku", function(module, exports) {

$parcel$export(module.exports, "_config", () => _config);
$parcel$export(module.exports, "_isString", () => _isString);
$parcel$export(module.exports, "_isUndefined", () => _isUndefined);
$parcel$export(module.exports, "_numExp", () => _numExp);
$parcel$export(module.exports, "_numWithUnitExp", () => _numWithUnitExp);
$parcel$export(module.exports, "_relExp", () => _relExp);
$parcel$export(module.exports, "gsap", () => gsap);
$parcel$export(module.exports, "_missingPlugin", () => _missingPlugin);
$parcel$export(module.exports, "_plugins", () => _plugins);
$parcel$export(module.exports, "GSCache", () => GSCache);
$parcel$export(module.exports, "_getCache", () => _getCache);
$parcel$export(module.exports, "toArray", () => toArray);
$parcel$export(module.exports, "_getProperty", () => _getProperty);
$parcel$export(module.exports, "_forEachName", () => _forEachName);
$parcel$export(module.exports, "_round", () => _round);
$parcel$export(module.exports, "_parseRelative", () => _parseRelative);
$parcel$export(module.exports, "_setDefaults", () => _setDefaults);
$parcel$export(module.exports, "_removeLinkedListItem", () => _removeLinkedListItem);
$parcel$export(module.exports, "_ticker", () => _ticker);
$parcel$export(module.exports, "Timeline", () => Timeline);
$parcel$export(module.exports, "Tween", () => Tween);
$parcel$export(module.exports, "getUnit", () => getUnit);
$parcel$export(module.exports, "clamp", () => clamp);
$parcel$export(module.exports, "selector", () => selector);
$parcel$export(module.exports, "shuffle", () => shuffle);
$parcel$export(module.exports, "distribute", () => distribute);
$parcel$export(module.exports, "_roundModifier", () => _roundModifier);
$parcel$export(module.exports, "snap", () => snap);
$parcel$export(module.exports, "random", () => random);
$parcel$export(module.exports, "pipe", () => pipe);
$parcel$export(module.exports, "unitize", () => unitize);
$parcel$export(module.exports, "normalize", () => normalize);
$parcel$export(module.exports, "mapRange", () => mapRange);
$parcel$export(module.exports, "wrap", () => wrap);
$parcel$export(module.exports, "wrapYoyo", () => wrapYoyo);
$parcel$export(module.exports, "_replaceRandom", () => _replaceRandom);
$parcel$export(module.exports, "interpolate", () => interpolate);
$parcel$export(module.exports, "_getSetter", () => _getSetter);
$parcel$export(module.exports, "PropTween", () => PropTween);
$parcel$export(module.exports, "splitColor", () => splitColor);
$parcel$export(module.exports, "_colorExp", () => _colorExp);
$parcel$export(module.exports, "_colorStringFilter", () => _colorStringFilter);
$parcel$export(module.exports, "Animation", () => Animation);
$parcel$export(module.exports, "_renderComplexString", () => _renderComplexString);
$parcel$export(module.exports, "_checkPlugin", () => _checkPlugin);
$parcel$export(module.exports, "_sortPropTweensByPriority", () => _sortPropTweensByPriority);
$parcel$export(module.exports, "Power0", () => Power0);
$parcel$export(module.exports, "Power1", () => Power1);
$parcel$export(module.exports, "Power2", () => Power2);
$parcel$export(module.exports, "Power3", () => Power3);
$parcel$export(module.exports, "Power4", () => Power4);
$parcel$export(module.exports, "Linear", () => Linear);
$parcel$export(module.exports, "Quad", () => Quad);
$parcel$export(module.exports, "Cubic", () => Cubic);
$parcel$export(module.exports, "Quart", () => Quart);
$parcel$export(module.exports, "Quint", () => Quint);
$parcel$export(module.exports, "Strong", () => Strong);
$parcel$export(module.exports, "Elastic", () => Elastic);
$parcel$export(module.exports, "Back", () => Back);
$parcel$export(module.exports, "SteppedEase", () => SteppedEase);
$parcel$export(module.exports, "Bounce", () => Bounce);
$parcel$export(module.exports, "Sine", () => Sine);
$parcel$export(module.exports, "Expo", () => Expo);
$parcel$export(module.exports, "Circ", () => Circ);
$parcel$export(module.exports, "TweenMax", () => Tween);
$parcel$export(module.exports, "TweenLite", () => Tween);
$parcel$export(module.exports, "TimelineMax", () => Timeline);
$parcel$export(module.exports, "TimelineLite", () => Timeline);
$parcel$export(module.exports, "default", () => gsap);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (_windowExists() && config) {
        // edge case: some build tools may pass in a null/undefined value
        config = !config.name && config["default"] || config; //UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else config && _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _raf = _win.requestAnimationFrame;
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? _win.cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), true);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (animation._ts || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.vars.immediateRender ? -Infinity : this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://greensock.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, onUpdateParams = vars.onUpdateParams, callbackScope = vars.callbackScope, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate,
                onUpdateParams: onUpdateParams,
                callbackScope: callbackScope,
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return 1;
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://greensock.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values.
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -_tinyNum : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time)) return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? _interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c);
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) {
            var tweens = this.getTweens();
            this.data.forEach(function(t) {
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            }); // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t.globalTime(0),
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            this.data.forEach(function(e) {
                return !(e instanceof Tween) && e.revert && e.revert(revert);
            });
            this._r.forEach(function(f) {
                return f(revert, _this4);
            });
            this.isReverted = true;
        } else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context);
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.2";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

const $e8de77a7e14f36ab$var$CONTENT_ATTR = 'data-ck-accordion-content';
const $e8de77a7e14f36ab$var$COLLAPSED_ATTR = 'data-ck-collapsed';
const $e8de77a7e14f36ab$var$INNER_CLASS = 'ck-accordion_inner';
/**
 * Initializes the accordion functionality.
 *
 * Motion lives in CSS (Webflow → Custom Code component → custom-styles embed): the content element becomes a one-row grid whose
 * row animates between 0fr and 1fr, so no height measuring is needed. While collapsed the
 * content is `inert`, `aria-hidden` and `visibility: hidden`, so nothing inside it can be
 * clicked, tabbed to, or read by assistive tech.
 *
 * @example
 * ```html
 * <div ck-accordion-group> <!-- optional: only one open at a time -->
 *   <div ck-accordion>
 *     <button>Accordion 1</button>
 *     <div>Content 1</div>
 *   </div>
 * </div>
 * ```
 */ let $e8de77a7e14f36ab$var$nextId = 0;
function $e8de77a7e14f36ab$export$2e2bcd8739ae039(root = document) {
    root.querySelectorAll('[ck-accordion]').forEach((accordion)=>{
        if (accordion.hasAttribute('data-ck-accordion-ready')) return;
        accordion.setAttribute('data-ck-accordion-ready', '');
        const index = $e8de77a7e14f36ab$var$nextId++;
        const button = accordion.querySelector(':scope > button');
        const content = button?.nextElementSibling;
        if (!button || !content) return;
        $e8de77a7e14f36ab$var$wrapContent(content);
        $e8de77a7e14f36ab$var$ensureAriaControlsAndID(button, content, index);
        $e8de77a7e14f36ab$var$setCollapsed(button, content, true);
        button.addEventListener('click', ()=>$e8de77a7e14f36ab$var$toggleAccordion(button, content));
    });
}
/** Moves the content's children into an inner wrapper so the grid-row animation can clip them. */ const $e8de77a7e14f36ab$var$wrapContent = (content)=>{
    content.setAttribute($e8de77a7e14f36ab$var$CONTENT_ATTR, '');
    if (content.querySelector(`:scope > .${$e8de77a7e14f36ab$var$INNER_CLASS}`)) return;
    const inner = document.createElement('div');
    inner.className = $e8de77a7e14f36ab$var$INNER_CLASS;
    while(content.firstChild)inner.appendChild(content.firstChild);
    content.appendChild(inner);
};
const $e8de77a7e14f36ab$var$toggleAccordion = (button, content)=>{
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    const group = button.closest('[ck-accordion-group]');
    if (group) group.querySelectorAll('[ck-accordion]').forEach((other)=>{
        const otherButton = other.querySelector(':scope > button');
        const otherContent = otherButton?.nextElementSibling;
        if (otherButton && otherContent && otherButton !== button) $e8de77a7e14f36ab$var$setCollapsed(otherButton, otherContent, true);
    });
    $e8de77a7e14f36ab$var$setCollapsed(button, content, isExpanded);
};
const $e8de77a7e14f36ab$var$setCollapsed = (button, content, collapsed)=>{
    button.setAttribute('aria-expanded', String(!collapsed));
    content.setAttribute('aria-hidden', String(collapsed));
    content.toggleAttribute($e8de77a7e14f36ab$var$COLLAPSED_ATTR, collapsed);
    // `inert` blocks focus, clicks and AT exposure for everything inside the closed drawer.
    content.toggleAttribute('inert', collapsed);
};
/**
 * Ensures the ARIA controls and ID requirements are set correctly.
 * If the content element doesn't have an ID, it assigns a unique one based on the index.
 */ const $e8de77a7e14f36ab$var$ensureAriaControlsAndID = (button, content, index)=>{
    content.id = content.id || `accordion-content-${index}`;
    button.setAttribute('aria-controls', content.id);
};


/**
 * Function to convert an HTML element to a different tag type while keeping the same attributes and children.
 *
 * @param {HTMLElement} el - The original HTML element that will be converted.
 * @param {string} tag - The new tag type the original element will be converted to.
 * @returns {HTMLElement} The new HTML element with the specified tag, attributes and children of the original element.
 */ const $3725beb56f0bb89d$export$64d8551c266151 = (el, tag)=>{
    const newElement = document.createElement(tag);
    newElement.innerHTML = el.innerHTML;
    Array.from(el.attributes).forEach((attr)=>{
        newElement.setAttribute(attr.name, attr.value);
    });
    el.parentNode?.replaceChild(newElement, el);
    return newElement;
};
const $3725beb56f0bb89d$export$9bb0e144ba4929ca = (el, placeFocusBefore)=>{
    let focusMethod, ogti, tempEl;
    const onblurEl = function(_e) {
        if (el.getAttribute('data-ogti') && ogti) el.setAttribute('tabindex', ogti);
        else el.removeAttribute('tabindex');
        el.removeAttribute('data-ogti');
        el.removeEventListener('focusout', focusMethod);
    };
    const onblurTempEl = function(_e) {
        tempEl.removeEventListener('focusout', focusMethod);
        tempEl.parentNode?.removeChild(tempEl);
    };
    const focusEl = function(theEl) {
        theEl.setAttribute('tabindex', '-1');
        theEl.addEventListener('focusout', focusMethod);
        theEl.focus();
    };
    focusMethod = onblurEl;
    if (placeFocusBefore) {
        tempEl = document.createElement('span');
        if (typeof placeFocusBefore === 'string') tempEl.innerHTML = placeFocusBefore;
        tempEl.setAttribute('style', 'position: absolute;height: 1px;width: 1px;margin: -1px;padding: 0;overflow: hidden;clip: rect(0 0 0 0);border: 0;');
        const newEl = el.parentNode?.insertBefore(tempEl, el);
        focusMethod = onblurTempEl;
        if (newEl) focusEl(newEl);
    } else {
        ogti = el.getAttribute('tabindex');
        if (ogti) el.setAttribute('data-ogti', ogti);
        focusEl(el);
    }
};
function $3725beb56f0bb89d$export$de363e709c412c8a(callbackFunction, limit) {
    let tick = false;
    return function() {
        if (!tick) {
            callbackFunction();
            tick = true;
            setTimeout(function() {
                tick = false;
            }, limit);
        }
    };
}
const $3725beb56f0bb89d$export$b1163bac65e099a = [
    'a[href]:not([tabindex^="-"])',
    'area[href]:not([tabindex^="-"])',
    'input:not([type="hidden"]):not([type="radio"]):not([disabled]):not([tabindex^="-"])',
    'input[type="radio"]:not([disabled]):not([tabindex^="-"]):checked',
    'select:not([disabled]):not([tabindex^="-"])',
    'textarea:not([disabled]):not([tabindex^="-"])',
    'button:not([disabled]):not([tabindex^="-"])',
    'iframe:not([tabindex^="-"])',
    'audio[controls]:not([tabindex^="-"])',
    'video[controls]:not([tabindex^="-"])',
    '[contenteditable]:not([tabindex^="-"])',
    '[tabindex]:not([tabindex^="-"])'
];
const $3725beb56f0bb89d$export$61319805fa787d = 'a[href]:not([tabindex^="-"]), area[href]:not([tabindex^="-"]), input:not([type="hidden"]):not([type="radio"]):not([disabled]):not([tabindex^="-"]), input[type="radio"]:not([disabled]):not([tabindex^="-"]):checked, select:not([disabled]):not([tabindex^="-"]), textarea:not([disabled]):not([tabindex^="-"]), button:not([disabled]):not([tabindex^="-"]), iframe:not([tabindex^="-"]), audio[controls]:not([tabindex^="-"]), video[controls]:not([tabindex^="-"]), [contenteditable]:not([tabindex^="-"]), [tabindex]:not([tabindex^="-"])';


const $15fdbb7456fb85b0$var$Anchors = ()=>{
    Array.from(document.querySelectorAll('[href^="#"]:not([href="#"])')).forEach((anchorLink)=>{
        anchorLink.addEventListener('click', function() {
            const section = document.querySelector(`[href="${anchorLink.getAttribute('href')}"]`);
            if (section) {
                const sectionHeading = section.querySelector('h1, h2, h3, h4, h5, h6');
                if (sectionHeading) (0, $3725beb56f0bb89d$export$9bb0e144ba4929ca)(sectionHeading, true);
                else (0, $3725beb56f0bb89d$export$9bb0e144ba4929ca)(section, true);
            }
        });
    });
};
var $15fdbb7456fb85b0$export$2e2bcd8739ae039 = $15fdbb7456fb85b0$var$Anchors;



var $lN1ku = parcelRequire("lN1ku");
/*!
 * CSSPlugin 3.12.2
 * https://greensock.com
 *
 * Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $lN1ku = parcelRequire("lN1ku");
var $a5929905f2a22260$var$_win, $a5929905f2a22260$var$_doc, $a5929905f2a22260$var$_docElement, $a5929905f2a22260$var$_pluginInitted, $a5929905f2a22260$var$_tempDiv, $a5929905f2a22260$var$_tempDivStyler, $a5929905f2a22260$var$_recentSetterPlugin, $a5929905f2a22260$var$_reverting, $a5929905f2a22260$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $a5929905f2a22260$var$_transformProps = {}, $a5929905f2a22260$var$_RAD2DEG = 180 / Math.PI, $a5929905f2a22260$var$_DEG2RAD = Math.PI / 180, $a5929905f2a22260$var$_atan2 = Math.atan2, $a5929905f2a22260$var$_bigNum = 1e8, $a5929905f2a22260$var$_capsExp = /([A-Z])/g, $a5929905f2a22260$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $a5929905f2a22260$var$_complexExp = /[\s,\(]\S/, $a5929905f2a22260$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $a5929905f2a22260$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $a5929905f2a22260$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $a5929905f2a22260$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$a5929905f2a22260$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $a5929905f2a22260$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $a5929905f2a22260$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $a5929905f2a22260$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $a5929905f2a22260$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $a5929905f2a22260$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $a5929905f2a22260$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $a5929905f2a22260$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $a5929905f2a22260$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $a5929905f2a22260$var$_transformProp = "transform", $a5929905f2a22260$var$_transformOriginProp = $a5929905f2a22260$var$_transformProp + "Origin", $a5929905f2a22260$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style;
    if (property in $a5929905f2a22260$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $a5929905f2a22260$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $a5929905f2a22260$var$_get(target, a);
            }) : this.tfm[property] = target._gsap.x ? target._gsap[property] : $a5929905f2a22260$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
        } else return $a5929905f2a22260$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($a5929905f2a22260$var$_transformProp) >= 0) return;
        if (target._gsap.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($a5929905f2a22260$var$_transformOriginProp, isNotCSS, "");
        }
        property = $a5929905f2a22260$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $a5929905f2a22260$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $a5929905f2a22260$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($a5929905f2a22260$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $a5929905f2a22260$var$_reverting();
        if ((!i || !i.isStart) && !style[$a5929905f2a22260$var$_transformProp]) {
            $a5929905f2a22260$var$_removeIndependentTransforms(style);
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $a5929905f2a22260$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $a5929905f2a22260$var$_revertStyle,
        save: $a5929905f2a22260$var$_saveStyle
    };
    target._gsap || (0, $lN1ku.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $a5929905f2a22260$var$_supports3D, $a5929905f2a22260$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $a5929905f2a22260$var$_doc.createElementNS ? $a5929905f2a22260$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $a5929905f2a22260$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e.style ? e : $a5929905f2a22260$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $a5929905f2a22260$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($a5929905f2a22260$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $a5929905f2a22260$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $a5929905f2a22260$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $a5929905f2a22260$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $a5929905f2a22260$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($a5929905f2a22260$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $a5929905f2a22260$var$_prefixes[i] : "") + property;
}, $a5929905f2a22260$var$_initCore = function _initCore() {
    if ($a5929905f2a22260$var$_windowExists() && window.document) {
        $a5929905f2a22260$var$_win = window;
        $a5929905f2a22260$var$_doc = $a5929905f2a22260$var$_win.document;
        $a5929905f2a22260$var$_docElement = $a5929905f2a22260$var$_doc.documentElement;
        $a5929905f2a22260$var$_tempDiv = $a5929905f2a22260$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $a5929905f2a22260$var$_tempDivStyler = $a5929905f2a22260$export$a232bb0480ae674a("div");
        $a5929905f2a22260$var$_transformProp = $a5929905f2a22260$export$8cbef5dd49a09c8b($a5929905f2a22260$var$_transformProp);
        $a5929905f2a22260$var$_transformOriginProp = $a5929905f2a22260$var$_transformProp + "Origin";
        $a5929905f2a22260$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $a5929905f2a22260$var$_supports3D = !!$a5929905f2a22260$export$8cbef5dd49a09c8b("perspective");
        $a5929905f2a22260$var$_reverting = (0, $lN1ku.gsap).core.reverting;
        $a5929905f2a22260$var$_pluginInitted = 1;
    }
}, $a5929905f2a22260$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $a5929905f2a22260$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $a5929905f2a22260$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $a5929905f2a22260$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $a5929905f2a22260$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $a5929905f2a22260$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $a5929905f2a22260$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $a5929905f2a22260$var$_getBBoxHack || (bounds = $a5929905f2a22260$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$a5929905f2a22260$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$a5929905f2a22260$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $a5929905f2a22260$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $a5929905f2a22260$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$a5929905f2a22260$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style;
        if (property in $a5929905f2a22260$var$_transformProps && property !== $a5929905f2a22260$var$_transformOriginProp) property = $a5929905f2a22260$var$_transformProp;
        if (style.removeProperty) {
            if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(property.replace($a5929905f2a22260$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $a5929905f2a22260$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $lN1ku.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $a5929905f2a22260$var$_renderNonTweeningValueOnlyAtEnd : $a5929905f2a22260$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $a5929905f2a22260$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $a5929905f2a22260$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$a5929905f2a22260$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $a5929905f2a22260$var$_tempDiv.style, horizontal = $a5929905f2a22260$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $a5929905f2a22260$var$_nonConvertibleUnits[unit] || $a5929905f2a22260$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $a5929905f2a22260$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($a5929905f2a22260$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $lN1ku._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $a5929905f2a22260$var$_doc || !parent.appendChild) parent = $a5929905f2a22260$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $lN1ku._ticker).time && !cache.uncache) return (0, $lN1ku._round)(curValue / cache.width * amount);
    else {
        (toPercent || curUnit === "%") && !$a5929905f2a22260$var$_nonStandardLayouts[$a5929905f2a22260$var$_getComputedProperty(parent, "display")] && (style.position = $a5929905f2a22260$var$_getComputedProperty(target, "position"));
        parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
        parent.appendChild($a5929905f2a22260$var$_tempDiv);
        px = $a5929905f2a22260$var$_tempDiv[measureProperty];
        parent.removeChild($a5929905f2a22260$var$_tempDiv);
        style.position = "absolute";
        if (horizontal && toPercent) {
            cache = (0, $lN1ku._getCache)(parent);
            cache.time = (0, $lN1ku._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $lN1ku._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $a5929905f2a22260$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $a5929905f2a22260$var$_pluginInitted || $a5929905f2a22260$var$_initCore();
    if (property in $a5929905f2a22260$var$_propertyAliases && property !== "transform") {
        property = $a5929905f2a22260$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($a5929905f2a22260$var$_transformProps[property] && property !== "transform") {
        value = $a5929905f2a22260$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $a5929905f2a22260$var$_firstTwoOnly($a5929905f2a22260$var$_getComputedProperty(target, $a5929905f2a22260$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $a5929905f2a22260$var$_specialProps[property] && $a5929905f2a22260$var$_specialProps[property](target, property, unit) || $a5929905f2a22260$var$_getComputedProperty(target, property) || (0, $lN1ku._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $a5929905f2a22260$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $a5929905f2a22260$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://greensock.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $a5929905f2a22260$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $a5929905f2a22260$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $a5929905f2a22260$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://greensock.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $lN1ku.PropTween)(this._pt, target.style, prop, 0, 1, (0, $lN1ku._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        target.style[prop] = end;
        end = $a5929905f2a22260$var$_getComputedProperty(target, prop) || end;
        target.style[prop] = start;
    }
    a = [
        start,
        end
    ];
    (0, $lN1ku._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $lN1ku._numWithUnitExp)) || [];
    endValues = end.match((0, $lN1ku._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $lN1ku._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $lN1ku._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $lN1ku._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $lN1ku._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $a5929905f2a22260$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $a5929905f2a22260$var$_renderNonTweeningValueOnlyAtEnd : $a5929905f2a22260$var$_renderNonTweeningValue;
    (0, $lN1ku._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $a5929905f2a22260$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $a5929905f2a22260$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $a5929905f2a22260$var$_keywordToPercent[x] || x;
    split[1] = $a5929905f2a22260$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $a5929905f2a22260$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($a5929905f2a22260$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $a5929905f2a22260$var$_transformOriginProp : $a5929905f2a22260$var$_transformProp;
                }
                $a5929905f2a22260$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $a5929905f2a22260$var$_removeProperty(target, $a5929905f2a22260$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $a5929905f2a22260$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $a5929905f2a22260$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$a5929905f2a22260$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $lN1ku.PropTween)(plugin._pt, target, property, 0, 0, $a5929905f2a22260$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $a5929905f2a22260$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $a5929905f2a22260$var$_rotationalProperties = {}, $a5929905f2a22260$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $a5929905f2a22260$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $a5929905f2a22260$var$_getComputedProperty(target, $a5929905f2a22260$var$_transformProp);
    return $a5929905f2a22260$var$_isNullTransform(matrixString) ? $a5929905f2a22260$var$_identity2DMatrix : matrixString.substr(7).match((0, $lN1ku._numExp)).map((0, $lN1ku._round));
}, $a5929905f2a22260$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $lN1ku._getCache)(target), style = target.style, matrix = $a5929905f2a22260$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $a5929905f2a22260$var$_identity2DMatrix : matrix;
    } else if (matrix === $a5929905f2a22260$var$_identity2DMatrix && !target.offsetParent && target !== $a5929905f2a22260$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $a5929905f2a22260$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $a5929905f2a22260$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $a5929905f2a22260$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $a5929905f2a22260$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $a5929905f2a22260$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $a5929905f2a22260$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $a5929905f2a22260$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
    } else if (matrix !== $a5929905f2a22260$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y;
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$a5929905f2a22260$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $a5929905f2a22260$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $a5929905f2a22260$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $a5929905f2a22260$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $a5929905f2a22260$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $a5929905f2a22260$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $lN1ku.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $a5929905f2a22260$var$_getComputedProperty(target, $a5929905f2a22260$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $a5929905f2a22260$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$a5929905f2a22260$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$a5929905f2a22260$var$_transformProp] !== "none" ? cs[$a5929905f2a22260$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $a5929905f2a22260$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $a5929905f2a22260$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $a5929905f2a22260$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $a5929905f2a22260$var$_atan2(b, a) * $a5929905f2a22260$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $a5929905f2a22260$var$_atan2(c, d) * $a5929905f2a22260$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $a5929905f2a22260$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $a5929905f2a22260$var$_atan2(a32, a33);
            rotationX = angle * $a5929905f2a22260$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $a5929905f2a22260$var$_atan2(-c, a33);
            rotationY = angle * $a5929905f2a22260$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $a5929905f2a22260$var$_atan2(b, a);
            rotation = angle * $a5929905f2a22260$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $lN1ku._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $lN1ku._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $a5929905f2a22260$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $a5929905f2a22260$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$a5929905f2a22260$var$_isNullTransform($a5929905f2a22260$var$_getComputedProperty(target, $a5929905f2a22260$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $lN1ku._round)(scaleX);
    cache.scaleY = (0, $lN1ku._round)(scaleY);
    cache.rotation = (0, $lN1ku._round)(rotation) + deg;
    cache.rotationX = (0, $lN1ku._round)(rotationX) + deg;
    cache.rotationY = (0, $lN1ku._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) style[$a5929905f2a22260$var$_transformOriginProp] = $a5929905f2a22260$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $lN1ku._config).force3D;
    cache.renderTransform = cache.svg ? $a5929905f2a22260$var$_renderSVGTransforms : $a5929905f2a22260$var$_supports3D ? $a5929905f2a22260$var$_renderCSSTransforms : $a5929905f2a22260$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $a5929905f2a22260$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$a5929905f2a22260$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $lN1ku.getUnit)(start);
    return (0, $lN1ku._round)(parseFloat(start) + parseFloat($a5929905f2a22260$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $a5929905f2a22260$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $a5929905f2a22260$var$_renderCSSTransforms(ratio, cache);
}, $a5929905f2a22260$var$_zeroDeg = "0deg", $a5929905f2a22260$var$_zeroPx = "0px", $a5929905f2a22260$var$_endParenthesis = ") ", $a5929905f2a22260$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $a5929905f2a22260$var$_zeroDeg || rotationY !== $a5929905f2a22260$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $a5929905f2a22260$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $a5929905f2a22260$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $a5929905f2a22260$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $a5929905f2a22260$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $a5929905f2a22260$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $a5929905f2a22260$var$_zeroPx) transforms += "perspective(" + transformPerspective + $a5929905f2a22260$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $a5929905f2a22260$var$_zeroPx || y !== $a5929905f2a22260$var$_zeroPx || z !== $a5929905f2a22260$var$_zeroPx) transforms += z !== $a5929905f2a22260$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $a5929905f2a22260$var$_endParenthesis;
    if (rotation !== $a5929905f2a22260$var$_zeroDeg) transforms += "rotate(" + rotation + $a5929905f2a22260$var$_endParenthesis;
    if (rotationY !== $a5929905f2a22260$var$_zeroDeg) transforms += "rotateY(" + rotationY + $a5929905f2a22260$var$_endParenthesis;
    if (rotationX !== $a5929905f2a22260$var$_zeroDeg) transforms += "rotateX(" + rotationX + $a5929905f2a22260$var$_endParenthesis;
    if (skewX !== $a5929905f2a22260$var$_zeroDeg || skewY !== $a5929905f2a22260$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $a5929905f2a22260$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $a5929905f2a22260$var$_endParenthesis;
    target.style[$a5929905f2a22260$var$_transformProp] = transforms || "translate(0, 0)";
}, $a5929905f2a22260$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $a5929905f2a22260$var$_DEG2RAD;
        skewX *= $a5929905f2a22260$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $a5929905f2a22260$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $lN1ku._round)(a11);
        a21 = (0, $lN1ku._round)(a21);
        a12 = (0, $lN1ku._round)(a12);
        a22 = (0, $lN1ku._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $a5929905f2a22260$var$_convertToUnit(target, "x", x, "px");
        ty = $a5929905f2a22260$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $lN1ku._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $lN1ku._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $lN1ku._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $lN1ku._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$a5929905f2a22260$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $a5929905f2a22260$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $lN1ku._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $a5929905f2a22260$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $a5929905f2a22260$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $a5929905f2a22260$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $lN1ku.PropTween)(plugin._pt, target, property, startNum, change, $a5929905f2a22260$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $a5929905f2a22260$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $a5929905f2a22260$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $a5929905f2a22260$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$a5929905f2a22260$var$_transformProp] = transforms;
        endCache = $a5929905f2a22260$var$_parseTransform(target, 1);
        $a5929905f2a22260$var$_removeProperty(target, $a5929905f2a22260$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$a5929905f2a22260$var$_transformProp];
        style[$a5929905f2a22260$var$_transformProp] = transforms;
        endCache = $a5929905f2a22260$var$_parseTransform(target, 1);
        style[$a5929905f2a22260$var$_transformProp] = startValue;
    }
    for(p in $a5929905f2a22260$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $lN1ku.getUnit)(startValue);
            endUnit = (0, $lN1ku.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $a5929905f2a22260$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $lN1ku.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $a5929905f2a22260$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $a5929905f2a22260$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $lN1ku._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $a5929905f2a22260$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $a5929905f2a22260$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $a5929905f2a22260$export$855822f522f18eef = {
    name: "css",
    register: $a5929905f2a22260$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $a5929905f2a22260$var$_pluginInitted || $a5929905f2a22260$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $a5929905f2a22260$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $lN1ku._plugins)[p] && (0, $lN1ku._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $a5929905f2a22260$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $lN1ku._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $lN1ku._colorExp).lastIndex = 0;
                if (!(0, $lN1ku._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $lN1ku.getUnit)(startValue);
                    endUnit = (0, $lN1ku.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $a5929905f2a22260$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $lN1ku._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $lN1ku._replaceRandom)(startValue));
                    (0, $lN1ku.getUnit)(startValue + "") || (startValue += (0, $lN1ku._config).units[p] || (0, $lN1ku.getUnit)($a5929905f2a22260$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $a5929905f2a22260$var$_get(target, p)); // can't work with relative values
                } else startValue = $a5929905f2a22260$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $a5929905f2a22260$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $a5929905f2a22260$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $a5929905f2a22260$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $a5929905f2a22260$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $a5929905f2a22260$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $a5929905f2a22260$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $lN1ku.PropTween)(this._pt, style, $a5929905f2a22260$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $lN1ku.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $lN1ku._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $a5929905f2a22260$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($a5929905f2a22260$var$_transformOriginProp, 0, style[$a5929905f2a22260$var$_transformOriginProp]);
                        endValue = $a5929905f2a22260$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $a5929905f2a22260$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $a5929905f2a22260$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $a5929905f2a22260$var$_addNonTweeningPT(this, style, p, $a5929905f2a22260$var$_firstTwoOnly(startValue), $a5929905f2a22260$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $a5929905f2a22260$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $a5929905f2a22260$var$_rotationalProperties) {
                        $a5929905f2a22260$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $lN1ku._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $a5929905f2a22260$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $a5929905f2a22260$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $a5929905f2a22260$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$a5929905f2a22260$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $lN1ku.getUnit)(endValue) || (p in (0, $lN1ku._config).units ? (0, $lN1ku._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $a5929905f2a22260$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $lN1ku.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $lN1ku._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $a5929905f2a22260$var$_renderRoundedCSSProp : $a5929905f2a22260$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $a5929905f2a22260$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $lN1ku._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $a5929905f2a22260$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $lN1ku._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$a5929905f2a22260$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $a5929905f2a22260$var$_get,
    aliases: $a5929905f2a22260$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $a5929905f2a22260$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $a5929905f2a22260$var$_transformProps && property !== $a5929905f2a22260$var$_transformOriginProp && (target._gsap.x || $a5929905f2a22260$var$_get(target, "x")) ? plugin && $a5929905f2a22260$var$_recentSetterPlugin === plugin ? property === "scale" ? $a5929905f2a22260$var$_setterScale : $a5929905f2a22260$var$_setterTransform : ($a5929905f2a22260$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $a5929905f2a22260$var$_setterScaleWithRender : $a5929905f2a22260$var$_setterTransformWithRender) : target.style && !(0, $lN1ku._isUndefined)(target.style[property]) ? $a5929905f2a22260$var$_setterCSSStyle : ~property.indexOf("-") ? $a5929905f2a22260$var$_setterCSSProp : (0, $lN1ku._getSetter)(target, property);
    },
    core: {
        _removeProperty: $a5929905f2a22260$var$_removeProperty,
        _getMatrix: $a5929905f2a22260$var$_getMatrix
    }
};
(0, $lN1ku.gsap).utils.checkPrefix = $a5929905f2a22260$export$8cbef5dd49a09c8b;
(0, $lN1ku.gsap).core.getStyleSaver = $a5929905f2a22260$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $lN1ku._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $a5929905f2a22260$var$_transformProps[name] = 1;
    });
    (0, $lN1ku._forEachName)(rotation, function(name) {
        (0, $lN1ku._config).units[name] = "deg";
        $a5929905f2a22260$var$_rotationalProperties[name] = 1;
    });
    $a5929905f2a22260$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $lN1ku._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $a5929905f2a22260$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $lN1ku._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $lN1ku._config).units[name] = "px";
});
(0, $lN1ku.gsap).registerPlugin($a5929905f2a22260$export$855822f522f18eef);


var $cab97051f2b305ae$export$99ee26438460406a = (0, $lN1ku.gsap).registerPlugin((0, $a5929905f2a22260$export$855822f522f18eef)) || (0, $lN1ku.gsap), // to protect from tree shaking
$cab97051f2b305ae$export$7b23975ad686bf91 = $cab97051f2b305ae$export$99ee26438460406a.core.Tween;


/*!
 * ScrollTrigger 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ function $6f3f677ef5e7a33c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6f3f677ef5e7a33c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6f3f677ef5e7a33c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6f3f677ef5e7a33c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $6f3f677ef5e7a33c$var$gsap, $6f3f677ef5e7a33c$var$_coreInitted, $6f3f677ef5e7a33c$var$_clamp, $6f3f677ef5e7a33c$var$_win, $6f3f677ef5e7a33c$var$_doc, $6f3f677ef5e7a33c$var$_docEl, $6f3f677ef5e7a33c$var$_body, $6f3f677ef5e7a33c$var$_isTouch, $6f3f677ef5e7a33c$var$_pointerType, $6f3f677ef5e7a33c$var$ScrollTrigger, $6f3f677ef5e7a33c$var$_root, $6f3f677ef5e7a33c$var$_normalizer, $6f3f677ef5e7a33c$var$_eventTypes, $6f3f677ef5e7a33c$var$_context, $6f3f677ef5e7a33c$var$_getGSAP = function _getGSAP() {
    return $6f3f677ef5e7a33c$var$gsap || typeof window !== "undefined" && ($6f3f677ef5e7a33c$var$gsap = window.gsap) && $6f3f677ef5e7a33c$var$gsap.registerPlugin && $6f3f677ef5e7a33c$var$gsap;
}, $6f3f677ef5e7a33c$var$_startup = 1, $6f3f677ef5e7a33c$var$_observers = [], $6f3f677ef5e7a33c$export$3cd1cee43d19b683 = [], $6f3f677ef5e7a33c$export$d8e56d510a804d0a = [], $6f3f677ef5e7a33c$var$_getTime = Date.now, $6f3f677ef5e7a33c$var$_bridge = function _bridge(name, value) {
    return value;
}, $6f3f677ef5e7a33c$var$_integrate = function _integrate() {
    var core = $6f3f677ef5e7a33c$var$ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, $6f3f677ef5e7a33c$export$3cd1cee43d19b683);
    proxies.push.apply(proxies, $6f3f677ef5e7a33c$export$d8e56d510a804d0a);
    $6f3f677ef5e7a33c$export$3cd1cee43d19b683 = scrollers;
    $6f3f677ef5e7a33c$export$d8e56d510a804d0a = proxies;
    $6f3f677ef5e7a33c$var$_bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, $6f3f677ef5e7a33c$export$6078f1ef08b38af9 = function _getProxyProp(element, property) {
    return ~$6f3f677ef5e7a33c$export$d8e56d510a804d0a.indexOf(element) && $6f3f677ef5e7a33c$export$d8e56d510a804d0a[$6f3f677ef5e7a33c$export$d8e56d510a804d0a.indexOf(element) + 1][property];
}, $6f3f677ef5e7a33c$export$4330f3a92e5d2e94 = function _isViewport(el) {
    return !!~$6f3f677ef5e7a33c$var$_root.indexOf(el);
}, $6f3f677ef5e7a33c$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $6f3f677ef5e7a33c$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $6f3f677ef5e7a33c$var$_scrollLeft = "scrollLeft", $6f3f677ef5e7a33c$var$_scrollTop = "scrollTop", $6f3f677ef5e7a33c$var$_onScroll = function _onScroll() {
    return $6f3f677ef5e7a33c$var$_normalizer && $6f3f677ef5e7a33c$var$_normalizer.isPressed || $6f3f677ef5e7a33c$export$3cd1cee43d19b683.cache++;
}, $6f3f677ef5e7a33c$var$_scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            $6f3f677ef5e7a33c$var$_startup && ($6f3f677ef5e7a33c$var$_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = $6f3f677ef5e7a33c$var$_normalizer && $6f3f677ef5e7a33c$var$_normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || ($6f3f677ef5e7a33c$var$_normalizer && $6f3f677ef5e7a33c$var$_normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = $6f3f677ef5e7a33c$export$3cd1cee43d19b683.cache;
            isNormalizing && $6f3f677ef5e7a33c$var$_bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || $6f3f677ef5e7a33c$export$3cd1cee43d19b683.cache !== cachingFunc.cacheID || $6f3f677ef5e7a33c$var$_bridge("ref")) {
            cachingFunc.cacheID = $6f3f677ef5e7a33c$export$3cd1cee43d19b683.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, $6f3f677ef5e7a33c$export$b2cabb342cb0ebe1 = {
    s: $6f3f677ef5e7a33c$var$_scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: $6f3f677ef5e7a33c$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $6f3f677ef5e7a33c$var$_win.scrollTo(value, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d.sc()) : $6f3f677ef5e7a33c$var$_win.pageXOffset || $6f3f677ef5e7a33c$var$_doc[$6f3f677ef5e7a33c$var$_scrollLeft] || $6f3f677ef5e7a33c$var$_docEl[$6f3f677ef5e7a33c$var$_scrollLeft] || $6f3f677ef5e7a33c$var$_body[$6f3f677ef5e7a33c$var$_scrollLeft] || 0;
    })
}, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d = {
    s: $6f3f677ef5e7a33c$var$_scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: $6f3f677ef5e7a33c$export$b2cabb342cb0ebe1,
    sc: $6f3f677ef5e7a33c$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $6f3f677ef5e7a33c$var$_win.scrollTo($6f3f677ef5e7a33c$export$b2cabb342cb0ebe1.sc(), value) : $6f3f677ef5e7a33c$var$_win.pageYOffset || $6f3f677ef5e7a33c$var$_doc[$6f3f677ef5e7a33c$var$_scrollTop] || $6f3f677ef5e7a33c$var$_docEl[$6f3f677ef5e7a33c$var$_scrollTop] || $6f3f677ef5e7a33c$var$_body[$6f3f677ef5e7a33c$var$_scrollTop] || 0;
    })
}, $6f3f677ef5e7a33c$export$937374fea3f88711 = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || $6f3f677ef5e7a33c$var$gsap.utils.toArray)(t)[0] || (typeof t === "string" && $6f3f677ef5e7a33c$var$gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, $6f3f677ef5e7a33c$export$8665aac53dad5647 = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    $6f3f677ef5e7a33c$export$4330f3a92e5d2e94(element) && (element = $6f3f677ef5e7a33c$var$_doc.scrollingElement || $6f3f677ef5e7a33c$var$_docEl);
    var i = $6f3f677ef5e7a33c$export$3cd1cee43d19b683.indexOf(element), offset = sc === $6f3f677ef5e7a33c$export$8e40fc98ff518e9d.sc ? 1 : 2;
    !~i && (i = $6f3f677ef5e7a33c$export$3cd1cee43d19b683.push(element) - 1);
    $6f3f677ef5e7a33c$export$3cd1cee43d19b683[i + offset] || $6f3f677ef5e7a33c$var$_addListener(element, "scroll", $6f3f677ef5e7a33c$var$_onScroll); // clear the cache when a scroll occurs
    var prev = $6f3f677ef5e7a33c$export$3cd1cee43d19b683[i + offset], func = prev || ($6f3f677ef5e7a33c$export$3cd1cee43d19b683[i + offset] = $6f3f677ef5e7a33c$var$_scrollCacheFunc($6f3f677ef5e7a33c$export$6078f1ef08b38af9(element, s), true) || ($6f3f677ef5e7a33c$export$4330f3a92e5d2e94(element) ? sc : $6f3f677ef5e7a33c$var$_scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = $6f3f677ef5e7a33c$var$gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, $6f3f677ef5e7a33c$export$5de019f4480f0f8d = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = $6f3f677ef5e7a33c$var$_getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = $6f3f677ef5e7a33c$var$_getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = $6f3f677ef5e7a33c$var$_getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, $6f3f677ef5e7a33c$var$_getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, $6f3f677ef5e7a33c$var$_getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, $6f3f677ef5e7a33c$var$_setScrollTrigger = function _setScrollTrigger() {
    $6f3f677ef5e7a33c$var$ScrollTrigger = $6f3f677ef5e7a33c$var$gsap.core.globals().ScrollTrigger;
    $6f3f677ef5e7a33c$var$ScrollTrigger && $6f3f677ef5e7a33c$var$ScrollTrigger.core && $6f3f677ef5e7a33c$var$_integrate();
}, $6f3f677ef5e7a33c$var$_initCore = function _initCore(core) {
    $6f3f677ef5e7a33c$var$gsap = core || $6f3f677ef5e7a33c$var$_getGSAP();
    if ($6f3f677ef5e7a33c$var$gsap && typeof document !== "undefined" && document.body) {
        $6f3f677ef5e7a33c$var$_win = window;
        $6f3f677ef5e7a33c$var$_doc = document;
        $6f3f677ef5e7a33c$var$_docEl = $6f3f677ef5e7a33c$var$_doc.documentElement;
        $6f3f677ef5e7a33c$var$_body = $6f3f677ef5e7a33c$var$_doc.body;
        $6f3f677ef5e7a33c$var$_root = [
            $6f3f677ef5e7a33c$var$_win,
            $6f3f677ef5e7a33c$var$_doc,
            $6f3f677ef5e7a33c$var$_docEl,
            $6f3f677ef5e7a33c$var$_body
        ];
        $6f3f677ef5e7a33c$var$_clamp = $6f3f677ef5e7a33c$var$gsap.utils.clamp;
        $6f3f677ef5e7a33c$var$_context = $6f3f677ef5e7a33c$var$gsap.core.context || function() {};
        $6f3f677ef5e7a33c$var$_pointerType = "onpointerenter" in $6f3f677ef5e7a33c$var$_body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        $6f3f677ef5e7a33c$var$_isTouch = $6f3f677ef5e7a33c$export$c1cbdee04e18ea8b.isTouch = $6f3f677ef5e7a33c$var$_win.matchMedia && $6f3f677ef5e7a33c$var$_win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in $6f3f677ef5e7a33c$var$_win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        $6f3f677ef5e7a33c$var$_eventTypes = $6f3f677ef5e7a33c$export$c1cbdee04e18ea8b.eventTypes = ("ontouchstart" in $6f3f677ef5e7a33c$var$_docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in $6f3f677ef5e7a33c$var$_docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return $6f3f677ef5e7a33c$var$_startup = 0;
        }, 500);
        $6f3f677ef5e7a33c$var$_setScrollTrigger();
        $6f3f677ef5e7a33c$var$_coreInitted = 1;
    }
    return $6f3f677ef5e7a33c$var$_coreInitted;
};
$6f3f677ef5e7a33c$export$b2cabb342cb0ebe1.op = $6f3f677ef5e7a33c$export$8e40fc98ff518e9d;
$6f3f677ef5e7a33c$export$3cd1cee43d19b683.cache = 0;
var $6f3f677ef5e7a33c$export$c1cbdee04e18ea8b = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        $6f3f677ef5e7a33c$var$_coreInitted || $6f3f677ef5e7a33c$var$_initCore($6f3f677ef5e7a33c$var$gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        $6f3f677ef5e7a33c$var$ScrollTrigger || $6f3f677ef5e7a33c$var$_setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = $6f3f677ef5e7a33c$export$937374fea3f88711(target) || $6f3f677ef5e7a33c$var$_docEl;
        this.vars = vars;
        ignore && (ignore = $6f3f677ef5e7a33c$var$gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat($6f3f677ef5e7a33c$var$_win.getComputedStyle($6f3f677ef5e7a33c$var$_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, scrollFuncX = $6f3f677ef5e7a33c$export$8665aac53dad5647(target, $6f3f677ef5e7a33c$export$b2cabb342cb0ebe1), scrollFuncY = $6f3f677ef5e7a33c$export$8665aac53dad5647(target, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && $6f3f677ef5e7a33c$var$_eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = $6f3f677ef5e7a33c$export$4330f3a92e5d2e94(target), ownerDoc = target.ownerDocument || $6f3f677ef5e7a33c$var$_doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = $6f3f677ef5e7a33c$var$_getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && ~ignore.indexOf(e.target) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = $6f3f677ef5e7a33c$var$_getAbsoluteMax(deltaX), dy = self.deltaY = $6f3f677ef5e7a33c$var$_getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDrag(self);
                    dragged = false;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = $6f3f677ef5e7a33c$var$_getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum) {
                onDrag && (dragged = true);
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
                isDragging || onDragStart && onDragStart(self);
            }
        }, _onPress = self.onPress = function(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = $6f3f677ef5e7a33c$var$_getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            $6f3f677ef5e7a33c$var$_addListener(isNormalizer ? target : ownerDoc, $6f3f677ef5e7a33c$var$_eventTypes[1], _onDrag, preventDefault, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e) {
            if (_ignoreCheck(e, 1)) return;
            $6f3f677ef5e7a33c$var$_removeListener(isNormalizer ? target : ownerDoc, $6f3f677ef5e7a33c$var$_eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = $6f3f677ef5e7a33c$var$_getEvent(e);
            if (!wasDragging && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset();
                if (preventDefault && allowClicks) $6f3f677ef5e7a33c$var$gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if ($6f3f677ef5e7a33c$var$_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, $6f3f677ef5e7a33c$var$_win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, wasDragging);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = $6f3f677ef5e7a33c$var$_getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? $6f3f677ef5e7a33c$var$_win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || $6f3f677ef5e7a33c$var$_getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = $6f3f677ef5e7a33c$var$gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = $6f3f677ef5e7a33c$export$5de019f4480f0f8d(0, 50, true);
        self._vy = $6f3f677ef5e7a33c$export$5de019f4480f0f8d(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        $6f3f677ef5e7a33c$var$_context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                $6f3f677ef5e7a33c$var$_addListener(isViewport ? ownerDoc : target, "scroll", $6f3f677ef5e7a33c$var$_onScroll);
                type.indexOf("scroll") >= 0 && $6f3f677ef5e7a33c$var$_addListener(isViewport ? ownerDoc : target, "scroll", onScroll, preventDefault, capture);
                type.indexOf("wheel") >= 0 && $6f3f677ef5e7a33c$var$_addListener(target, "wheel", _onWheel, preventDefault, capture);
                if (type.indexOf("touch") >= 0 && $6f3f677ef5e7a33c$var$_isTouch || type.indexOf("pointer") >= 0) {
                    $6f3f677ef5e7a33c$var$_addListener(target, $6f3f677ef5e7a33c$var$_eventTypes[0], _onPress, preventDefault, capture);
                    $6f3f677ef5e7a33c$var$_addListener(ownerDoc, $6f3f677ef5e7a33c$var$_eventTypes[2], _onRelease);
                    $6f3f677ef5e7a33c$var$_addListener(ownerDoc, $6f3f677ef5e7a33c$var$_eventTypes[3], _onRelease);
                    allowClicks && $6f3f677ef5e7a33c$var$_addListener(target, "click", clickCapture, false, true);
                    onClick && $6f3f677ef5e7a33c$var$_addListener(target, "click", _onClick);
                    onGestureStart && $6f3f677ef5e7a33c$var$_addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && $6f3f677ef5e7a33c$var$_addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && $6f3f677ef5e7a33c$var$_addListener(target, $6f3f677ef5e7a33c$var$_pointerType + "enter", _onHover);
                    onHoverEnd && $6f3f677ef5e7a33c$var$_addListener(target, $6f3f677ef5e7a33c$var$_pointerType + "leave", _onHoverEnd);
                    onMove && $6f3f677ef5e7a33c$var$_addListener(target, $6f3f677ef5e7a33c$var$_pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                $6f3f677ef5e7a33c$var$_observers.filter(function(o) {
                    return o !== self && $6f3f677ef5e7a33c$export$4330f3a92e5d2e94(o.target);
                }).length || $6f3f677ef5e7a33c$var$_removeListener(isViewport ? ownerDoc : target, "scroll", $6f3f677ef5e7a33c$var$_onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    $6f3f677ef5e7a33c$var$_removeListener(isNormalizer ? target : ownerDoc, $6f3f677ef5e7a33c$var$_eventTypes[1], _onDrag, true);
                }
                $6f3f677ef5e7a33c$var$_removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                $6f3f677ef5e7a33c$var$_removeListener(target, "wheel", _onWheel, capture);
                $6f3f677ef5e7a33c$var$_removeListener(target, $6f3f677ef5e7a33c$var$_eventTypes[0], _onPress, capture);
                $6f3f677ef5e7a33c$var$_removeListener(ownerDoc, $6f3f677ef5e7a33c$var$_eventTypes[2], _onRelease);
                $6f3f677ef5e7a33c$var$_removeListener(ownerDoc, $6f3f677ef5e7a33c$var$_eventTypes[3], _onRelease);
                $6f3f677ef5e7a33c$var$_removeListener(target, "click", clickCapture, true);
                $6f3f677ef5e7a33c$var$_removeListener(target, "click", _onClick);
                $6f3f677ef5e7a33c$var$_removeListener(ownerDoc, "gesturestart", _onGestureStart);
                $6f3f677ef5e7a33c$var$_removeListener(ownerDoc, "gestureend", _onGestureEnd);
                $6f3f677ef5e7a33c$var$_removeListener(target, $6f3f677ef5e7a33c$var$_pointerType + "enter", _onHover);
                $6f3f677ef5e7a33c$var$_removeListener(target, $6f3f677ef5e7a33c$var$_pointerType + "leave", _onHoverEnd);
                $6f3f677ef5e7a33c$var$_removeListener(target, $6f3f677ef5e7a33c$var$_pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = $6f3f677ef5e7a33c$var$_observers.indexOf(self);
            i >= 0 && $6f3f677ef5e7a33c$var$_observers.splice(i, 1);
            $6f3f677ef5e7a33c$var$_normalizer === self && ($6f3f677ef5e7a33c$var$_normalizer = 0);
        };
        $6f3f677ef5e7a33c$var$_observers.push(self);
        isNormalizer && $6f3f677ef5e7a33c$export$4330f3a92e5d2e94(target) && ($6f3f677ef5e7a33c$var$_normalizer = self);
        self.enable(event);
    };
    $6f3f677ef5e7a33c$var$_createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
$6f3f677ef5e7a33c$export$c1cbdee04e18ea8b.version = "3.12.2";
$6f3f677ef5e7a33c$export$c1cbdee04e18ea8b.create = function(vars) {
    return new $6f3f677ef5e7a33c$export$c1cbdee04e18ea8b(vars);
};
$6f3f677ef5e7a33c$export$c1cbdee04e18ea8b.register = $6f3f677ef5e7a33c$var$_initCore;
$6f3f677ef5e7a33c$export$c1cbdee04e18ea8b.getAll = function() {
    return $6f3f677ef5e7a33c$var$_observers.slice();
};
$6f3f677ef5e7a33c$export$c1cbdee04e18ea8b.getById = function(id) {
    return $6f3f677ef5e7a33c$var$_observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
$6f3f677ef5e7a33c$var$_getGSAP() && $6f3f677ef5e7a33c$var$gsap.registerPlugin($6f3f677ef5e7a33c$export$c1cbdee04e18ea8b);


var $8395061df1725b8d$var$gsap, $8395061df1725b8d$var$_coreInitted, $8395061df1725b8d$var$_win, $8395061df1725b8d$var$_doc, $8395061df1725b8d$var$_docEl, $8395061df1725b8d$var$_body, $8395061df1725b8d$var$_root, $8395061df1725b8d$var$_resizeDelay, $8395061df1725b8d$var$_toArray, $8395061df1725b8d$var$_clamp, $8395061df1725b8d$var$_time2, $8395061df1725b8d$var$_syncInterval, $8395061df1725b8d$var$_refreshing, $8395061df1725b8d$var$_pointerIsDown, $8395061df1725b8d$var$_transformProp, $8395061df1725b8d$var$_i, $8395061df1725b8d$var$_prevWidth, $8395061df1725b8d$var$_prevHeight, $8395061df1725b8d$var$_autoRefresh, $8395061df1725b8d$var$_sort, $8395061df1725b8d$var$_suppressOverwrites, $8395061df1725b8d$var$_ignoreResize, $8395061df1725b8d$var$_normalizer, $8395061df1725b8d$var$_ignoreMobileResize, $8395061df1725b8d$var$_baseScreenHeight, $8395061df1725b8d$var$_baseScreenWidth, $8395061df1725b8d$var$_fixIOSBug, $8395061df1725b8d$var$_context, $8395061df1725b8d$var$_scrollRestoration, $8395061df1725b8d$var$_div100vh, $8395061df1725b8d$var$_100vh, $8395061df1725b8d$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$8395061df1725b8d$var$_startup = 1, $8395061df1725b8d$var$_getTime = Date.now, $8395061df1725b8d$var$_time1 = $8395061df1725b8d$var$_getTime(), $8395061df1725b8d$var$_lastScrollTime = 0, $8395061df1725b8d$var$_enabled = 0, $8395061df1725b8d$var$_parseClamp = function _parseClamp(value, type, self) {
    var clamp = $8395061df1725b8d$var$_isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, $8395061df1725b8d$var$_keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!$8395061df1725b8d$var$_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, $8395061df1725b8d$var$_rafBugFix = function _rafBugFix() {
    return $8395061df1725b8d$var$_enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
$8395061df1725b8d$var$_pointerDownHandler = function _pointerDownHandler() {
    return $8395061df1725b8d$var$_pointerIsDown = 1;
}, $8395061df1725b8d$var$_pointerUpHandler = function _pointerUpHandler() {
    return $8395061df1725b8d$var$_pointerIsDown = 0;
}, $8395061df1725b8d$var$_passThrough = function _passThrough(v) {
    return v;
}, $8395061df1725b8d$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $8395061df1725b8d$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $8395061df1725b8d$var$_getGSAP = function _getGSAP() {
    return $8395061df1725b8d$var$gsap || $8395061df1725b8d$var$_windowExists() && ($8395061df1725b8d$var$gsap = window.gsap) && $8395061df1725b8d$var$gsap.registerPlugin && $8395061df1725b8d$var$gsap;
}, $8395061df1725b8d$var$_isViewport = function _isViewport(e) {
    return !!~$8395061df1725b8d$var$_root.indexOf(e);
}, $8395061df1725b8d$var$_getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? $8395061df1725b8d$var$_100vh : $8395061df1725b8d$var$_win["inner" + dimensionProperty]) || $8395061df1725b8d$var$_docEl["client" + dimensionProperty] || $8395061df1725b8d$var$_body["client" + dimensionProperty];
}, $8395061df1725b8d$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return (0, $6f3f677ef5e7a33c$export$6078f1ef08b38af9)(element, "getBoundingClientRect") || ($8395061df1725b8d$var$_isViewport(element) ? function() {
        $8395061df1725b8d$var$_winOffsets.width = $8395061df1725b8d$var$_win.innerWidth;
        $8395061df1725b8d$var$_winOffsets.height = $8395061df1725b8d$var$_100vh;
        return $8395061df1725b8d$var$_winOffsets;
    } : function() {
        return $8395061df1725b8d$var$_getBounds(element);
    });
}, $8395061df1725b8d$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, $6f3f677ef5e7a33c$export$6078f1ef08b38af9)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $8395061df1725b8d$var$_getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, $8395061df1725b8d$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, $6f3f677ef5e7a33c$export$d8e56d510a804d0a).indexOf(element) ? $8395061df1725b8d$var$_getBoundsFunc(element) : function() {
        return $8395061df1725b8d$var$_winOffsets;
    };
}, $8395061df1725b8d$var$_maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, $6f3f677ef5e7a33c$export$6078f1ef08b38af9)(element, s)) ? a() - $8395061df1725b8d$var$_getBoundsFunc(element)()[d] : $8395061df1725b8d$var$_isViewport(element) ? ($8395061df1725b8d$var$_docEl[s] || $8395061df1725b8d$var$_body[s]) - $8395061df1725b8d$var$_getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, $8395061df1725b8d$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $8395061df1725b8d$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($8395061df1725b8d$var$_autoRefresh[i + 1])) && func($8395061df1725b8d$var$_autoRefresh[i], $8395061df1725b8d$var$_autoRefresh[i + 1], $8395061df1725b8d$var$_autoRefresh[i + 2]);
}, $8395061df1725b8d$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $8395061df1725b8d$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $8395061df1725b8d$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $8395061df1725b8d$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $8395061df1725b8d$var$_endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, $8395061df1725b8d$var$_callback = function _callback(self, func) {
    if (self.enabled) {
        var result = func(self);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, $8395061df1725b8d$var$_abs = Math.abs, $8395061df1725b8d$var$_left = "left", $8395061df1725b8d$var$_top = "top", $8395061df1725b8d$var$_right = "right", $8395061df1725b8d$var$_bottom = "bottom", $8395061df1725b8d$var$_width = "width", $8395061df1725b8d$var$_height = "height", $8395061df1725b8d$var$_Right = "Right", $8395061df1725b8d$var$_Left = "Left", $8395061df1725b8d$var$_Top = "Top", $8395061df1725b8d$var$_Bottom = "Bottom", $8395061df1725b8d$var$_padding = "padding", $8395061df1725b8d$var$_margin = "margin", $8395061df1725b8d$var$_Width = "Width", $8395061df1725b8d$var$_Height = "Height", $8395061df1725b8d$var$_px = "px", $8395061df1725b8d$var$_getComputedStyle = function _getComputedStyle(element) {
    return $8395061df1725b8d$var$_win.getComputedStyle(element);
}, $8395061df1725b8d$var$_makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = $8395061df1725b8d$var$_getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, $8395061df1725b8d$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $8395061df1725b8d$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $8395061df1725b8d$var$_getComputedStyle(element)[$8395061df1725b8d$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $8395061df1725b8d$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $8395061df1725b8d$var$_getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $8395061df1725b8d$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $8395061df1725b8d$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $8395061df1725b8d$var$gsap.utils.snap($8395061df1725b8d$var$_getLabelRatioArray(animation), value);
    };
}, $8395061df1725b8d$var$_snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = $8395061df1725b8d$var$gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, $8395061df1725b8d$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return $8395061df1725b8d$var$_snapDirectional($8395061df1725b8d$var$_getLabelRatioArray(timeline))(value, st.direction);
    };
}, $8395061df1725b8d$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $8395061df1725b8d$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $8395061df1725b8d$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $8395061df1725b8d$var$_wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, $8395061df1725b8d$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $8395061df1725b8d$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $8395061df1725b8d$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $8395061df1725b8d$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($8395061df1725b8d$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $8395061df1725b8d$var$_keywords ? $8395061df1725b8d$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $8395061df1725b8d$var$_createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = $8395061df1725b8d$var$_doc.createElement("div"), useFixedPosition = $8395061df1725b8d$var$_isViewport(container) || (0, $6f3f677ef5e7a33c$export$6078f1ef08b38af9)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $8395061df1725b8d$var$_body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d) ? $8395061df1725b8d$var$_right : $8395061df1725b8d$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $8395061df1725b8d$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $8395061df1725b8d$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $8395061df1725b8d$var$_Width] = 1;
    vars["border" + oppositeSide + $8395061df1725b8d$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $8395061df1725b8d$var$gsap.set(marker, vars);
}, $8395061df1725b8d$var$_triggers = [], $8395061df1725b8d$var$_ids = {}, $8395061df1725b8d$var$_rafID, $8395061df1725b8d$var$_sync = function _sync() {
    return $8395061df1725b8d$var$_getTime() - $8395061df1725b8d$var$_lastScrollTime > 34 && ($8395061df1725b8d$var$_rafID || ($8395061df1725b8d$var$_rafID = requestAnimationFrame($8395061df1725b8d$var$_updateAll)));
}, $8395061df1725b8d$var$_onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!$8395061df1725b8d$var$_normalizer || !$8395061df1725b8d$var$_normalizer.isPressed || $8395061df1725b8d$var$_normalizer.startX > $8395061df1725b8d$var$_body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).cache++;
        if ($8395061df1725b8d$var$_normalizer) $8395061df1725b8d$var$_rafID || ($8395061df1725b8d$var$_rafID = requestAnimationFrame($8395061df1725b8d$var$_updateAll));
        else $8395061df1725b8d$var$_updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        $8395061df1725b8d$var$_lastScrollTime || $8395061df1725b8d$var$_dispatch("scrollStart");
        $8395061df1725b8d$var$_lastScrollTime = $8395061df1725b8d$var$_getTime();
    }
}, $8395061df1725b8d$var$_setBaseDimensions = function _setBaseDimensions() {
    $8395061df1725b8d$var$_baseScreenWidth = $8395061df1725b8d$var$_win.innerWidth;
    $8395061df1725b8d$var$_baseScreenHeight = $8395061df1725b8d$var$_win.innerHeight;
}, $8395061df1725b8d$var$_onResize = function _onResize() {
    (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).cache++;
    !$8395061df1725b8d$var$_refreshing && !$8395061df1725b8d$var$_ignoreResize && !$8395061df1725b8d$var$_doc.fullscreenElement && !$8395061df1725b8d$var$_doc.webkitFullscreenElement && (!$8395061df1725b8d$var$_ignoreMobileResize || $8395061df1725b8d$var$_baseScreenWidth !== $8395061df1725b8d$var$_win.innerWidth || Math.abs($8395061df1725b8d$var$_win.innerHeight - $8395061df1725b8d$var$_baseScreenHeight) > $8395061df1725b8d$var$_win.innerHeight * 0.25) && $8395061df1725b8d$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$8395061df1725b8d$var$_listeners = {}, $8395061df1725b8d$var$_emptyArray = [], $8395061df1725b8d$var$_softRefresh = function _softRefresh() {
    return $8395061df1725b8d$var$_removeListener($8395061df1725b8d$export$875bcbe48555930, "scrollEnd", _softRefresh) || $8395061df1725b8d$var$_refreshAll(true);
}, $8395061df1725b8d$var$_dispatch = function _dispatch(type) {
    return $8395061df1725b8d$var$_listeners[type] && $8395061df1725b8d$var$_listeners[type].map(function(f) {
        return f();
    }) || $8395061df1725b8d$var$_emptyArray;
}, $8395061df1725b8d$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$8395061df1725b8d$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $8395061df1725b8d$var$_savedStyles.length; i += 5)if (!media || $8395061df1725b8d$var$_savedStyles[i + 4] && $8395061df1725b8d$var$_savedStyles[i + 4].query === media) {
        $8395061df1725b8d$var$_savedStyles[i].style.cssText = $8395061df1725b8d$var$_savedStyles[i + 1];
        $8395061df1725b8d$var$_savedStyles[i].getBBox && $8395061df1725b8d$var$_savedStyles[i].setAttribute("transform", $8395061df1725b8d$var$_savedStyles[i + 2] || "");
        $8395061df1725b8d$var$_savedStyles[i + 3].uncache = 1;
    }
}, $8395061df1725b8d$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($8395061df1725b8d$var$_i = 0; $8395061df1725b8d$var$_i < $8395061df1725b8d$var$_triggers.length; $8395061df1725b8d$var$_i++){
        trigger = $8395061df1725b8d$var$_triggers[$8395061df1725b8d$var$_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    media && $8395061df1725b8d$var$_revertRecorded(media);
    media || $8395061df1725b8d$var$_dispatch("revert");
}, $8395061df1725b8d$var$_clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).cache++;
    (force || !$8395061df1725b8d$var$_refreshingAll) && (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).forEach(function(obj) {
        return $8395061df1725b8d$var$_isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    $8395061df1725b8d$var$_isString(scrollRestoration) && ($8395061df1725b8d$var$_win.history.scrollRestoration = $8395061df1725b8d$var$_scrollRestoration = scrollRestoration);
}, $8395061df1725b8d$var$_refreshingAll, $8395061df1725b8d$var$_refreshID = 0, $8395061df1725b8d$var$_queueRefreshID, $8395061df1725b8d$var$_queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if ($8395061df1725b8d$var$_queueRefreshID !== $8395061df1725b8d$var$_refreshID) {
        var id = $8395061df1725b8d$var$_queueRefreshID = $8395061df1725b8d$var$_refreshID;
        requestAnimationFrame(function() {
            return id === $8395061df1725b8d$var$_refreshID && $8395061df1725b8d$var$_refreshAll(true);
        });
    }
}, $8395061df1725b8d$var$_refresh100vh = function _refresh100vh() {
    $8395061df1725b8d$var$_body.appendChild($8395061df1725b8d$var$_div100vh);
    $8395061df1725b8d$var$_100vh = $8395061df1725b8d$var$_div100vh.offsetHeight || $8395061df1725b8d$var$_win.innerHeight;
    $8395061df1725b8d$var$_body.removeChild($8395061df1725b8d$var$_div100vh);
}, $8395061df1725b8d$var$_refreshAll = function _refreshAll(force, skipRevert) {
    if ($8395061df1725b8d$var$_lastScrollTime && !force) {
        $8395061df1725b8d$var$_addListener($8395061df1725b8d$export$875bcbe48555930, "scrollEnd", $8395061df1725b8d$var$_softRefresh);
        return;
    }
    $8395061df1725b8d$var$_refresh100vh();
    $8395061df1725b8d$var$_refreshingAll = $8395061df1725b8d$export$875bcbe48555930.isRefreshing = true;
    (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).forEach(function(obj) {
        return $8395061df1725b8d$var$_isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    }); // force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
    var refreshInits = $8395061df1725b8d$var$_dispatch("refreshInit");
    $8395061df1725b8d$var$_sort && $8395061df1725b8d$export$875bcbe48555930.sort();
    skipRevert || $8395061df1725b8d$var$_revertAll();
    (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($8395061df1725b8d$var$_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    $8395061df1725b8d$var$_triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    $8395061df1725b8d$var$_triggers.forEach(function(t, i) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    $8395061df1725b8d$var$_triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = $8395061df1725b8d$var$_maxScroll(t.scroller, t._dir);
        (t.vars.end === "max" || t._endClamp && t.end > max) && t.setPositions(t.start, Math.max(t.start + 1, max), true);
    });
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($8395061df1725b8d$var$_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    $8395061df1725b8d$var$_clearScrollMemory($8395061df1725b8d$var$_scrollRestoration, 1);
    $8395061df1725b8d$var$_resizeDelay.pause();
    $8395061df1725b8d$var$_refreshID++;
    $8395061df1725b8d$var$_refreshingAll = 2;
    $8395061df1725b8d$var$_updateAll(2);
    $8395061df1725b8d$var$_triggers.forEach(function(t) {
        return $8395061df1725b8d$var$_isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    $8395061df1725b8d$var$_refreshingAll = $8395061df1725b8d$export$875bcbe48555930.isRefreshing = false;
    $8395061df1725b8d$var$_dispatch("refresh");
}, $8395061df1725b8d$var$_lastScroll = 0, $8395061df1725b8d$var$_direction = 1, $8395061df1725b8d$var$_primary, $8395061df1725b8d$var$_updateAll = function _updateAll(force) {
    if (!$8395061df1725b8d$var$_refreshingAll || force === 2) {
        $8395061df1725b8d$export$875bcbe48555930.isUpdating = true;
        $8395061df1725b8d$var$_primary && $8395061df1725b8d$var$_primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = $8395061df1725b8d$var$_triggers.length, time = $8395061df1725b8d$var$_getTime(), recordVelocity = time - $8395061df1725b8d$var$_time1 >= 50, scroll = l && $8395061df1725b8d$var$_triggers[0].scroll();
        $8395061df1725b8d$var$_direction = $8395061df1725b8d$var$_lastScroll > scroll ? -1 : 1;
        $8395061df1725b8d$var$_refreshingAll || ($8395061df1725b8d$var$_lastScroll = scroll);
        if (recordVelocity) {
            if ($8395061df1725b8d$var$_lastScrollTime && !$8395061df1725b8d$var$_pointerIsDown && time - $8395061df1725b8d$var$_lastScrollTime > 200) {
                $8395061df1725b8d$var$_lastScrollTime = 0;
                $8395061df1725b8d$var$_dispatch("scrollEnd");
            }
            $8395061df1725b8d$var$_time2 = $8395061df1725b8d$var$_time1;
            $8395061df1725b8d$var$_time1 = time;
        }
        if ($8395061df1725b8d$var$_direction < 0) {
            $8395061df1725b8d$var$_i = l;
            while($8395061df1725b8d$var$_i-- > 0)$8395061df1725b8d$var$_triggers[$8395061df1725b8d$var$_i] && $8395061df1725b8d$var$_triggers[$8395061df1725b8d$var$_i].update(0, recordVelocity);
            $8395061df1725b8d$var$_direction = 1;
        } else for($8395061df1725b8d$var$_i = 0; $8395061df1725b8d$var$_i < l; $8395061df1725b8d$var$_i++)$8395061df1725b8d$var$_triggers[$8395061df1725b8d$var$_i] && $8395061df1725b8d$var$_triggers[$8395061df1725b8d$var$_i].update(0, recordVelocity);
        $8395061df1725b8d$export$875bcbe48555930.isUpdating = false;
    }
    $8395061df1725b8d$var$_rafID = 0;
}, $8395061df1725b8d$var$_propNamesToCopy = [
    $8395061df1725b8d$var$_left,
    $8395061df1725b8d$var$_top,
    $8395061df1725b8d$var$_bottom,
    $8395061df1725b8d$var$_right,
    $8395061df1725b8d$var$_margin + $8395061df1725b8d$var$_Bottom,
    $8395061df1725b8d$var$_margin + $8395061df1725b8d$var$_Right,
    $8395061df1725b8d$var$_margin + $8395061df1725b8d$var$_Top,
    $8395061df1725b8d$var$_margin + $8395061df1725b8d$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], $8395061df1725b8d$var$_stateProps = $8395061df1725b8d$var$_propNamesToCopy.concat([
    $8395061df1725b8d$var$_width,
    $8395061df1725b8d$var$_height,
    "boxSizing",
    "max" + $8395061df1725b8d$var$_Width,
    "max" + $8395061df1725b8d$var$_Height,
    "position",
    $8395061df1725b8d$var$_margin,
    $8395061df1725b8d$var$_padding,
    $8395061df1725b8d$var$_padding + $8395061df1725b8d$var$_Top,
    $8395061df1725b8d$var$_padding + $8395061df1725b8d$var$_Right,
    $8395061df1725b8d$var$_padding + $8395061df1725b8d$var$_Bottom,
    $8395061df1725b8d$var$_padding + $8395061df1725b8d$var$_Left
]), $8395061df1725b8d$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $8395061df1725b8d$var$_setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) $8395061df1725b8d$var$_setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, $8395061df1725b8d$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = $8395061df1725b8d$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $8395061df1725b8d$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$8395061df1725b8d$var$_bottom] = pinStyle[$8395061df1725b8d$var$_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$8395061df1725b8d$var$_width] = $8395061df1725b8d$var$_getSize(pin, (0, $6f3f677ef5e7a33c$export$b2cabb342cb0ebe1)) + $8395061df1725b8d$var$_px;
        spacerStyle[$8395061df1725b8d$var$_height] = $8395061df1725b8d$var$_getSize(pin, (0, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d)) + $8395061df1725b8d$var$_px;
        spacerStyle[$8395061df1725b8d$var$_padding] = pinStyle[$8395061df1725b8d$var$_margin] = pinStyle[$8395061df1725b8d$var$_top] = pinStyle[$8395061df1725b8d$var$_left] = "0";
        $8395061df1725b8d$var$_setState(spacerState);
        pinStyle[$8395061df1725b8d$var$_width] = pinStyle["max" + $8395061df1725b8d$var$_Width] = cs[$8395061df1725b8d$var$_width];
        pinStyle[$8395061df1725b8d$var$_height] = pinStyle["max" + $8395061df1725b8d$var$_Height] = cs[$8395061df1725b8d$var$_height];
        pinStyle[$8395061df1725b8d$var$_padding] = cs[$8395061df1725b8d$var$_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, $8395061df1725b8d$var$_capsExp = /([A-Z])/g, $8395061df1725b8d$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $8395061df1725b8d$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($8395061df1725b8d$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $8395061df1725b8d$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $8395061df1725b8d$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($8395061df1725b8d$var$_stateProps[i], style[$8395061df1725b8d$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $8395061df1725b8d$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $8395061df1725b8d$var$_winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
$8395061df1725b8d$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    $8395061df1725b8d$var$_isFunction(value) && (value = value(self));
    if ($8395061df1725b8d$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $8395061df1725b8d$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!$8395061df1725b8d$var$_isNumber(value)) {
        $8395061df1725b8d$var$_isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, $6f3f677ef5e7a33c$export$937374fea3f88711)(trigger, self) || $8395061df1725b8d$var$_body;
        bounds = $8395061df1725b8d$var$_getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && $8395061df1725b8d$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $8395061df1725b8d$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $8395061df1725b8d$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $8395061df1725b8d$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $8395061df1725b8d$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = $8395061df1725b8d$var$gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && $8395061df1725b8d$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        $8395061df1725b8d$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($8395061df1725b8d$var$_body[p1], $8395061df1725b8d$var$_docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $8395061df1725b8d$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $8395061df1725b8d$var$_px);
        }
    }
    if (containerAnimation && element) {
        p1 = $8395061df1725b8d$var$_getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = $8395061df1725b8d$var$_getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, $8395061df1725b8d$var$_prefixExp = /(webkit|moz|length|cssText|inset)/i, $8395061df1725b8d$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $8395061df1725b8d$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $8395061df1725b8d$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$8395061df1725b8d$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $8395061df1725b8d$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, $8395061df1725b8d$var$_interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = value;
        return value;
    };
}, $8395061df1725b8d$var$_shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    $8395061df1725b8d$var$gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$8395061df1725b8d$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, $6f3f677ef5e7a33c$export$8665aac53dad5647)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = $8395061df1725b8d$var$_interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).cache++;
            $8395061df1725b8d$var$_updateAll();
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $8395061df1725b8d$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    $8395061df1725b8d$var$_addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    $8395061df1725b8d$export$875bcbe48555930.isTouch && $8395061df1725b8d$var$_addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var $8395061df1725b8d$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $8395061df1725b8d$var$_coreInitted || ScrollTrigger.register($8395061df1725b8d$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        $8395061df1725b8d$var$_context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!$8395061df1725b8d$var$_enabled) {
            this.update = this.refresh = this.kill = $8395061df1725b8d$var$_passThrough;
            return;
        }
        vars = $8395061df1725b8d$var$_setDefaults($8395061df1725b8d$var$_isString(vars) || $8395061df1725b8d$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $8395061df1725b8d$var$_defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, $6f3f677ef5e7a33c$export$b2cabb342cb0ebe1) : (0, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d), isToggle = !scrub && scrub !== 0, scroller = (0, $6f3f677ef5e7a33c$export$937374fea3f88711)(vars.scroller || $8395061df1725b8d$var$_win), scrollerCache = $8395061df1725b8d$var$gsap.core.getCache(scroller), isViewport = $8395061df1725b8d$var$_isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, $6f3f677ef5e7a33c$export$6078f1ef08b38af9)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $8395061df1725b8d$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($8395061df1725b8d$var$_getComputedStyle(scroller)["border" + direction.p2 + $8395061df1725b8d$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $8395061df1725b8d$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $8395061df1725b8d$var$_getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, $6f3f677ef5e7a33c$export$8665aac53dad5647)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            $8395061df1725b8d$var$_sort = 1;
            vars.refreshPriority === -9999 && ($8395061df1725b8d$var$_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $8395061df1725b8d$var$_getTweenCreator(scroller, (0, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d)),
            left: $8395061df1725b8d$var$_getTweenCreator(scroller, (0, $6f3f677ef5e7a33c$export$b2cabb342cb0ebe1))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = $8395061df1725b8d$var$_isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = $8395061df1725b8d$var$gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://greensock.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!$8395061df1725b8d$var$_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in $8395061df1725b8d$var$_body.style && $8395061df1725b8d$var$gsap.set(isViewport ? [
                $8395061df1725b8d$var$_body,
                $8395061df1725b8d$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).forEach(function(o) {
                return $8395061df1725b8d$var$_isFunction(o) && o.target === (isViewport ? $8395061df1725b8d$var$_doc.scrollingElement || $8395061df1725b8d$var$_docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = $8395061df1725b8d$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $8395061df1725b8d$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $8395061df1725b8d$var$_getLabelAtDirection(animation) : snap.directional !== false ? function(value, st) {
                return $8395061df1725b8d$var$_snapDirectional(snap.snapTo)(value, $8395061df1725b8d$var$_getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : $8395061df1725b8d$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $8395061df1725b8d$var$_isObject(snapDurClamp) ? $8395061df1725b8d$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $8395061df1725b8d$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $8395061df1725b8d$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = $8395061df1725b8d$var$_getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !$8395061df1725b8d$var$_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / ($8395061df1725b8d$var$_getTime() - $8395061df1725b8d$var$_time2) * 1000 || 0, change1 = $8395061df1725b8d$var$gsap.utils.clamp(-progress, 1 - progress, $8395061df1725b8d$var$_abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue = $8395061df1725b8d$var$_clamp(0, 1, snapFunc(naturalEnd, self)), endScroll = Math.round(start + endValue * change), _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= $8395061df1725b8d$var$_abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($8395061df1725b8d$var$_abs(Math.max($8395061df1725b8d$var$_abs(naturalEnd - totalProgress), $8395061df1725b8d$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: $8395061df1725b8d$var$_abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && _onComplete(self);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && onStart(self, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($8395061df1725b8d$var$_ids[id] = self);
        trigger = self.trigger = (0, $6f3f677ef5e7a33c$export$937374fea3f88711)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, $6f3f677ef5e7a33c$export$937374fea3f88711)(pin);
        $8395061df1725b8d$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $8395061df1725b8d$var$_margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && $8395061df1725b8d$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $8395061df1725b8d$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = $8395061df1725b8d$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, $6f3f677ef5e7a33c$export$937374fea3f88711)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = $8395061df1725b8d$var$_getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || $8395061df1725b8d$var$_doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = $8395061df1725b8d$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && $8395061df1725b8d$var$gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = $8395061df1725b8d$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $8395061df1725b8d$var$gsap.getProperty(pin);
            pinSetter = $8395061df1725b8d$var$gsap.quickSetter(pin, direction.a, $8395061df1725b8d$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $8395061df1725b8d$var$_swapPinIn(pin, spacer, cs);
            pinState = $8395061df1725b8d$var$_getState(pin);
        }
        if (markers) {
            markerVars = $8395061df1725b8d$var$_isObject(markers) ? $8395061df1725b8d$var$_setDefaults(markers, $8395061df1725b8d$var$_markerDefaults) : $8395061df1725b8d$var$_markerDefaults;
            markerStartTrigger = $8395061df1725b8d$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $8395061df1725b8d$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, $6f3f677ef5e7a33c$export$937374fea3f88711)((0, $6f3f677ef5e7a33c$export$6078f1ef08b38af9)(scroller, "content") || scroller);
            markerStart = this.markerStart = $8395061df1725b8d$var$_createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = $8395061df1725b8d$var$_createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = $8395061df1725b8d$var$gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, $8395061df1725b8d$var$_px));
            if (!useFixedPosition && !((0, $6f3f677ef5e7a33c$export$d8e56d510a804d0a).length && (0, $6f3f677ef5e7a33c$export$6078f1ef08b38af9)(scroller, "fixedMarkers") === true)) {
                $8395061df1725b8d$var$_makePositionable(isViewport ? $8395061df1725b8d$var$_body : scroller);
                $8395061df1725b8d$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $8395061df1725b8d$var$gsap.quickSetter(markerStartTrigger, direction.a, $8395061df1725b8d$var$_px);
                markerEndSetter = $8395061df1725b8d$var$gsap.quickSetter(markerEndTrigger, direction.a, $8395061df1725b8d$var$_px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return $8395061df1725b8d$var$_triggers[$8395061df1725b8d$var$_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return $8395061df1725b8d$var$_triggers[$8395061df1725b8d$var$_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = $8395061df1725b8d$var$_refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    $8395061df1725b8d$var$_refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) $8395061df1725b8d$var$_swapPinOut(pin, spacer, pinOriginalState);
                    else $8395061df1725b8d$var$_swapPinIn(pin, spacer, $8395061df1725b8d$var$_getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                $8395061df1725b8d$var$_refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if (($8395061df1725b8d$var$_refreshing || !self.enabled) && !force) return;
            if (pin && soft && $8395061df1725b8d$var$_lastScrollTime) {
                $8395061df1725b8d$var$_addListener(ScrollTrigger, "scrollEnd", $8395061df1725b8d$var$_softRefresh);
                return;
            }
            !$8395061df1725b8d$var$_refreshingAll && onRefreshInit && onRefreshInit(self);
            $8395061df1725b8d$var$_refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            invalidateOnRefresh && animation && animation.revert({
                kill: false
            }).invalidate();
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : $8395061df1725b8d$var$_maxScroll(scroller, direction), isFirstRefresh = change <= 0.01, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = $8395061df1725b8d$var$_isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = $8395061df1725b8d$var$_isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, $6f3f677ef5e7a33c$export$937374fea3f88711)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, $8395061df1725b8d$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && $8395061df1725b8d$var$_isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = $8395061df1725b8d$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = $8395061df1725b8d$var$gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i--){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = $8395061df1725b8d$var$_triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || ($8395061df1725b8d$var$_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== $8395061df1725b8d$var$_triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            $8395061df1725b8d$var$_isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = $8395061df1725b8d$var$_parseClamp(parsedStart, "start", self);
            start = $8395061df1725b8d$var$_parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            $8395061df1725b8d$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($8395061df1725b8d$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($8395061df1725b8d$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $8395061df1725b8d$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $8395061df1725b8d$var$_isString(parsedStart) ? parsedStart : (containerAnimation ? $8395061df1725b8d$var$gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = $8395061df1725b8d$var$_parseClamp(parsedEnd, "end", self);
            end = Math.max(start, $8395061df1725b8d$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $8395061df1725b8d$var$_triggers[i];
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !$8395061df1725b8d$var$_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, $8395061df1725b8d$var$_maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = $8395061df1725b8d$var$gsap.utils.clamp(0, 1, $8395061df1725b8d$var$gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                $8395061df1725b8d$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin) {
                cs = $8395061df1725b8d$var$_getComputedStyle(pin);
                isVertical = direction === (0, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://greensock.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? $8395061df1725b8d$var$_doc.scrollingElement || $8395061df1725b8d$var$_docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && $8395061df1725b8d$var$_getComputedStyle($8395061df1725b8d$var$_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                $8395061df1725b8d$var$_swapPinIn(pin, spacer, cs);
                pinState = $8395061df1725b8d$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $8395061df1725b8d$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, $6f3f677ef5e7a33c$export$8665aac53dad5647)(scroller, isVertical ? (0, $6f3f677ef5e7a33c$export$b2cabb342cb0ebe1) : (0, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $8395061df1725b8d$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $8395061df1725b8d$var$_padding ? $8395061df1725b8d$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    i && spacerState.push(direction.d, i + $8395061df1725b8d$var$_px); // for box-sizing: border-box (must include padding).
                    $8395061df1725b8d$var$_setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    $8395061df1725b8d$var$_triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $8395061df1725b8d$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $8395061df1725b8d$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$8395061df1725b8d$var$_width] = override["max" + $8395061df1725b8d$var$_Width] = Math.ceil(bounds.width) + $8395061df1725b8d$var$_px;
                    override[$8395061df1725b8d$var$_height] = override["max" + $8395061df1725b8d$var$_Height] = Math.ceil(bounds.height) + $8395061df1725b8d$var$_px;
                    override[$8395061df1725b8d$var$_margin] = override[$8395061df1725b8d$var$_margin + $8395061df1725b8d$var$_Top] = override[$8395061df1725b8d$var$_margin + $8395061df1725b8d$var$_Right] = override[$8395061df1725b8d$var$_margin + $8395061df1725b8d$var$_Bottom] = override[$8395061df1725b8d$var$_margin + $8395061df1725b8d$var$_Left] = "0";
                    override[$8395061df1725b8d$var$_padding] = cs[$8395061df1725b8d$var$_padding];
                    override[$8395061df1725b8d$var$_padding + $8395061df1725b8d$var$_Top] = cs[$8395061df1725b8d$var$_padding + $8395061df1725b8d$var$_Top];
                    override[$8395061df1725b8d$var$_padding + $8395061df1725b8d$var$_Right] = cs[$8395061df1725b8d$var$_padding + $8395061df1725b8d$var$_Right];
                    override[$8395061df1725b8d$var$_padding + $8395061df1725b8d$var$_Bottom] = cs[$8395061df1725b8d$var$_padding + $8395061df1725b8d$var$_Bottom];
                    override[$8395061df1725b8d$var$_padding + $8395061df1725b8d$var$_Left] = cs[$8395061df1725b8d$var$_padding + $8395061df1725b8d$var$_Left];
                    pinActiveState = $8395061df1725b8d$var$_copyState(pinOriginalState, override, pinReparent);
                    $8395061df1725b8d$var$_refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $8395061df1725b8d$var$_suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    $8395061df1725b8d$var$_suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $8395061df1725b8d$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = $8395061df1725b8d$var$_refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !$8395061df1725b8d$var$_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = $8395061df1725b8d$var$_getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            $8395061df1725b8d$var$_refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? $8395061df1725b8d$var$gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= $8395061df1725b8d$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= $8395061df1725b8d$var$gsap.getProperty(markerEndTrigger, direction.p);
                $8395061df1725b8d$var$_shiftMarker(markerStartTrigger, direction, markerStartOffset);
                $8395061df1725b8d$var$_shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                $8395061df1725b8d$var$_shiftMarker(markerEndTrigger, direction, markerEndOffset);
                $8395061df1725b8d$var$_shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !$8395061df1725b8d$var$_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !$8395061df1725b8d$var$_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / ($8395061df1725b8d$var$_getTime() - $8395061df1725b8d$var$_time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            $8395061df1725b8d$var$_endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? $8395061df1725b8d$var$_endAnimation(animation, animation.reversed()) : isToggle || $8395061df1725b8d$var$_endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = $8395061df1725b8d$var$_triggers.indexOf(self), a = self.direction > 0 ? $8395061df1725b8d$var$_triggers.slice(0, i).reverse() : $8395061df1725b8d$var$_triggers.slice(i + 1);
            return ($8395061df1725b8d$var$_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = $8395061df1725b8d$var$_refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            anticipatePin && !clipped && pin && !$8395061df1725b8d$var$_refreshing && !$8395061df1725b8d$var$_startup && $8395061df1725b8d$var$_lastScrollTime && start < scroll + (scroll - scroll2) / ($8395061df1725b8d$var$_getTime() - $8395061df1725b8d$var$_time2) * anticipatePin && (clipped = 0.0001);
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !$8395061df1725b8d$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && ($8395061df1725b8d$var$_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !$8395061df1725b8d$var$_refreshing && !$8395061df1725b8d$var$_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!($8395061df1725b8d$var$_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter($8395061df1725b8d$var$_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $8395061df1725b8d$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = $8395061df1725b8d$var$_getBounds(pin, true), _offset = scroll - start;
                                $8395061df1725b8d$var$_reparent(pin, $8395061df1725b8d$var$_body, bounds.top + (direction === (0, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d) ? _offset : 0) + $8395061df1725b8d$var$_px, bounds.left + (direction === (0, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d) ? 0 : _offset) + $8395061df1725b8d$var$_px);
                            } else $8395061df1725b8d$var$_reparent(pin, spacer);
                        }
                        $8395061df1725b8d$var$_setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$8395061df1725b8d$var$_refreshing && !$8395061df1725b8d$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$8395061df1725b8d$var$_limitCallbacks)) && $8395061df1725b8d$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$8395061df1725b8d$var$_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$8395061df1725b8d$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && $8395061df1725b8d$var$_callback(self, onToggle);
                        callbacks[toggleState] && $8395061df1725b8d$var$_callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && $8395061df1725b8d$var$_callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > ($8395061df1725b8d$var$_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        $8395061df1725b8d$var$_endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : $8395061df1725b8d$var$_endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !$8395061df1725b8d$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                $8395061df1725b8d$var$_addListener(scroller, "resize", $8395061df1725b8d$var$_onResize);
                isViewport || $8395061df1725b8d$var$_addListener(scroller, "scroll", $8395061df1725b8d$var$_onScroll);
                onRefreshInit && $8395061df1725b8d$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: $8395061df1725b8d$var$_keepClamp(newStart, keepClamp && !!self._startClamp),
                end: $8395061df1725b8d$var$_keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + $8395061df1725b8d$var$_px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + $8395061df1725b8d$var$_px;
                $8395061df1725b8d$var$_setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            if (self.enabled) {
                reset !== false && self.revert(true, true);
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $8395061df1725b8d$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $8395061df1725b8d$var$_triggers.length;
                    while(i--){
                        if ($8395061df1725b8d$var$_triggers[i].scroller === scroller && $8395061df1725b8d$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $8395061df1725b8d$var$_removeListener(scroller, "resize", $8395061df1725b8d$var$_onResize);
                    isViewport || $8395061df1725b8d$var$_removeListener(scroller, "scroll", $8395061df1725b8d$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete $8395061df1725b8d$var$_ids[id];
            var i = $8395061df1725b8d$var$_triggers.indexOf(self);
            i >= 0 && $8395061df1725b8d$var$_triggers.splice(i, 1);
            i === $8395061df1725b8d$var$_i && $8395061df1725b8d$var$_direction > 0 && $8395061df1725b8d$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            $8395061df1725b8d$var$_triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || $8395061df1725b8d$var$_refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            $8395061df1725b8d$var$_primary === self && ($8395061df1725b8d$var$_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $8395061df1725b8d$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        $8395061df1725b8d$var$_triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                start || end || self.refresh();
            };
            $8395061df1725b8d$var$gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && $8395061df1725b8d$var$_queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!$8395061df1725b8d$var$_coreInitted) {
            $8395061df1725b8d$var$gsap = core || $8395061df1725b8d$var$_getGSAP();
            $8395061df1725b8d$var$_windowExists() && window.document && ScrollTrigger.enable();
            $8395061df1725b8d$var$_coreInitted = $8395061df1725b8d$var$_enabled;
        }
        return $8395061df1725b8d$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)$8395061df1725b8d$var$_defaults[p] = config[p];
        return $8395061df1725b8d$var$_defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        $8395061df1725b8d$var$_enabled = 0;
        $8395061df1725b8d$var$_triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        $8395061df1725b8d$var$_removeListener($8395061df1725b8d$var$_win, "wheel", $8395061df1725b8d$var$_onScroll);
        $8395061df1725b8d$var$_removeListener($8395061df1725b8d$var$_doc, "scroll", $8395061df1725b8d$var$_onScroll);
        clearInterval($8395061df1725b8d$var$_syncInterval);
        $8395061df1725b8d$var$_removeListener($8395061df1725b8d$var$_doc, "touchcancel", $8395061df1725b8d$var$_passThrough);
        $8395061df1725b8d$var$_removeListener($8395061df1725b8d$var$_body, "touchstart", $8395061df1725b8d$var$_passThrough);
        $8395061df1725b8d$var$_multiListener($8395061df1725b8d$var$_removeListener, $8395061df1725b8d$var$_doc, "pointerdown,touchstart,mousedown", $8395061df1725b8d$var$_pointerDownHandler);
        $8395061df1725b8d$var$_multiListener($8395061df1725b8d$var$_removeListener, $8395061df1725b8d$var$_doc, "pointerup,touchend,mouseup", $8395061df1725b8d$var$_pointerUpHandler);
        $8395061df1725b8d$var$_resizeDelay.kill();
        $8395061df1725b8d$var$_iterateAutoRefresh($8395061df1725b8d$var$_removeListener);
        for(var i = 0; i < (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).length; i += 3){
            $8395061df1725b8d$var$_wheelListener($8395061df1725b8d$var$_removeListener, (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683)[i], (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683)[i + 1]);
            $8395061df1725b8d$var$_wheelListener($8395061df1725b8d$var$_removeListener, (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683)[i], (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        $8395061df1725b8d$var$_win = window;
        $8395061df1725b8d$var$_doc = document;
        $8395061df1725b8d$var$_docEl = $8395061df1725b8d$var$_doc.documentElement;
        $8395061df1725b8d$var$_body = $8395061df1725b8d$var$_doc.body;
        if ($8395061df1725b8d$var$gsap) {
            $8395061df1725b8d$var$_toArray = $8395061df1725b8d$var$gsap.utils.toArray;
            $8395061df1725b8d$var$_clamp = $8395061df1725b8d$var$gsap.utils.clamp;
            $8395061df1725b8d$var$_context = $8395061df1725b8d$var$gsap.core.context || $8395061df1725b8d$var$_passThrough;
            $8395061df1725b8d$var$_suppressOverwrites = $8395061df1725b8d$var$gsap.core.suppressOverwrites || $8395061df1725b8d$var$_passThrough;
            $8395061df1725b8d$var$_scrollRestoration = $8395061df1725b8d$var$_win.history.scrollRestoration || "auto";
            $8395061df1725b8d$var$_lastScroll = $8395061df1725b8d$var$_win.pageYOffset;
            $8395061df1725b8d$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if ($8395061df1725b8d$var$_body) {
                $8395061df1725b8d$var$_enabled = 1;
                $8395061df1725b8d$var$_div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                $8395061df1725b8d$var$_div100vh.style.height = "100vh";
                $8395061df1725b8d$var$_div100vh.style.position = "absolute";
                $8395061df1725b8d$var$_refresh100vh();
                $8395061df1725b8d$var$_rafBugFix();
                (0, $6f3f677ef5e7a33c$export$c1cbdee04e18ea8b).register($8395061df1725b8d$var$gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, $6f3f677ef5e7a33c$export$c1cbdee04e18ea8b).isTouch;
                $8395061df1725b8d$var$_fixIOSBug = (0, $6f3f677ef5e7a33c$export$c1cbdee04e18ea8b).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                $8395061df1725b8d$var$_addListener($8395061df1725b8d$var$_win, "wheel", $8395061df1725b8d$var$_onScroll); // mostly for 3rd party smooth scrolling libraries.
                $8395061df1725b8d$var$_root = [
                    $8395061df1725b8d$var$_win,
                    $8395061df1725b8d$var$_doc,
                    $8395061df1725b8d$var$_docEl,
                    $8395061df1725b8d$var$_body
                ];
                if ($8395061df1725b8d$var$gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = $8395061df1725b8d$var$gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    $8395061df1725b8d$var$gsap.addEventListener("matchMediaInit", function() {
                        return $8395061df1725b8d$var$_revertAll();
                    });
                    $8395061df1725b8d$var$gsap.addEventListener("matchMediaRevert", function() {
                        return $8395061df1725b8d$var$_revertRecorded();
                    });
                    $8395061df1725b8d$var$gsap.addEventListener("matchMedia", function() {
                        $8395061df1725b8d$var$_refreshAll(0, 1);
                        $8395061df1725b8d$var$_dispatch("matchMedia");
                    });
                    $8395061df1725b8d$var$gsap.matchMedia("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        $8395061df1725b8d$var$_setBaseDimensions();
                        return $8395061df1725b8d$var$_setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                $8395061df1725b8d$var$_setBaseDimensions();
                $8395061df1725b8d$var$_addListener($8395061df1725b8d$var$_doc, "scroll", $8395061df1725b8d$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyStyle = $8395061df1725b8d$var$_body.style, border = bodyStyle.borderTopStyle, AnimationProto = $8395061df1725b8d$var$gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = $8395061df1725b8d$var$_getBounds($8395061df1725b8d$var$_body);
                (0, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d).m = Math.round(bounds.top + (0, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, $6f3f677ef5e7a33c$export$b2cabb342cb0ebe1).m = Math.round(bounds.left + (0, $6f3f677ef5e7a33c$export$b2cabb342cb0ebe1).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style"); // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                $8395061df1725b8d$var$_syncInterval = setInterval($8395061df1725b8d$var$_sync, 250);
                $8395061df1725b8d$var$gsap.delayedCall(0.5, function() {
                    return $8395061df1725b8d$var$_startup = 0;
                });
                $8395061df1725b8d$var$_addListener($8395061df1725b8d$var$_doc, "touchcancel", $8395061df1725b8d$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                $8395061df1725b8d$var$_addListener($8395061df1725b8d$var$_body, "touchstart", $8395061df1725b8d$var$_passThrough); //works around Safari bug: https://greensock.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                $8395061df1725b8d$var$_multiListener($8395061df1725b8d$var$_addListener, $8395061df1725b8d$var$_doc, "pointerdown,touchstart,mousedown", $8395061df1725b8d$var$_pointerDownHandler);
                $8395061df1725b8d$var$_multiListener($8395061df1725b8d$var$_addListener, $8395061df1725b8d$var$_doc, "pointerup,touchend,mouseup", $8395061df1725b8d$var$_pointerUpHandler);
                $8395061df1725b8d$var$_transformProp = $8395061df1725b8d$var$gsap.utils.checkPrefix("transform");
                $8395061df1725b8d$var$_stateProps.push($8395061df1725b8d$var$_transformProp);
                $8395061df1725b8d$var$_coreInitted = $8395061df1725b8d$var$_getTime();
                $8395061df1725b8d$var$_resizeDelay = $8395061df1725b8d$var$gsap.delayedCall(0.2, $8395061df1725b8d$var$_refreshAll).pause();
                $8395061df1725b8d$var$_autoRefresh = [
                    $8395061df1725b8d$var$_doc,
                    "visibilitychange",
                    function() {
                        var w = $8395061df1725b8d$var$_win.innerWidth, h = $8395061df1725b8d$var$_win.innerHeight;
                        if ($8395061df1725b8d$var$_doc.hidden) {
                            $8395061df1725b8d$var$_prevWidth = w;
                            $8395061df1725b8d$var$_prevHeight = h;
                        } else if ($8395061df1725b8d$var$_prevWidth !== w || $8395061df1725b8d$var$_prevHeight !== h) $8395061df1725b8d$var$_onResize();
                    },
                    $8395061df1725b8d$var$_doc,
                    "DOMContentLoaded",
                    $8395061df1725b8d$var$_refreshAll,
                    $8395061df1725b8d$var$_win,
                    "load",
                    $8395061df1725b8d$var$_refreshAll,
                    $8395061df1725b8d$var$_win,
                    "resize",
                    $8395061df1725b8d$var$_onResize
                ];
                $8395061df1725b8d$var$_iterateAutoRefresh($8395061df1725b8d$var$_addListener);
                $8395061df1725b8d$var$_triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).length; i += 3){
                    $8395061df1725b8d$var$_wheelListener($8395061df1725b8d$var$_removeListener, (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683)[i], (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683)[i + 1]);
                    $8395061df1725b8d$var$_wheelListener($8395061df1725b8d$var$_removeListener, (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683)[i], (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683)[i + 2]);
                }
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($8395061df1725b8d$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($8395061df1725b8d$var$_syncInterval) || ($8395061df1725b8d$var$_syncInterval = ms) && setInterval($8395061df1725b8d$var$_sync, ms);
        "ignoreMobileResize" in vars && ($8395061df1725b8d$var$_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            $8395061df1725b8d$var$_iterateAutoRefresh($8395061df1725b8d$var$_removeListener) || $8395061df1725b8d$var$_iterateAutoRefresh($8395061df1725b8d$var$_addListener, vars.autoRefreshEvents || "none");
            $8395061df1725b8d$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, $6f3f677ef5e7a33c$export$937374fea3f88711)(target), i = (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).indexOf(t), isViewport = $8395061df1725b8d$var$_isViewport(t);
        if (~i) (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, $6f3f677ef5e7a33c$export$d8e56d510a804d0a).unshift($8395061df1725b8d$var$_win, vars, $8395061df1725b8d$var$_body, vars, $8395061df1725b8d$var$_docEl, vars) : (0, $6f3f677ef5e7a33c$export$d8e56d510a804d0a).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        $8395061df1725b8d$var$_triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = ($8395061df1725b8d$var$_isString(element) ? (0, $6f3f677ef5e7a33c$export$937374fea3f88711)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? $8395061df1725b8d$var$_width : $8395061df1725b8d$var$_height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < $8395061df1725b8d$var$_win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < $8395061df1725b8d$var$_win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        $8395061df1725b8d$var$_isString(element) && (element = (0, $6f3f677ef5e7a33c$export$937374fea3f88711)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? $8395061df1725b8d$var$_width : $8395061df1725b8d$var$_height], offset = referencePoint == null ? size / 2 : referencePoint in $8395061df1725b8d$var$_keywords ? $8395061df1725b8d$var$_keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / $8395061df1725b8d$var$_win.innerWidth : (bounds.top + offset) / $8395061df1725b8d$var$_win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        $8395061df1725b8d$var$_triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = $8395061df1725b8d$var$_listeners.killAll || [];
            $8395061df1725b8d$var$_listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
$8395061df1725b8d$export$875bcbe48555930.version = "3.12.2";
$8395061df1725b8d$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $8395061df1725b8d$var$_toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = $8395061df1725b8d$var$_savedStyles.indexOf(target);
            i >= 0 && $8395061df1725b8d$var$_savedStyles.splice(i, 5);
            $8395061df1725b8d$var$_savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), $8395061df1725b8d$var$gsap.core.getCache(target), $8395061df1725b8d$var$_context());
        }
    }) : $8395061df1725b8d$var$_savedStyles;
};
$8395061df1725b8d$export$875bcbe48555930.revert = function(soft, media) {
    return $8395061df1725b8d$var$_revertAll(!soft, media);
};
$8395061df1725b8d$export$875bcbe48555930.create = function(vars, animation) {
    return new $8395061df1725b8d$export$875bcbe48555930(vars, animation);
};
$8395061df1725b8d$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $8395061df1725b8d$var$_onResize() : ($8395061df1725b8d$var$_coreInitted || $8395061df1725b8d$export$875bcbe48555930.register()) && $8395061df1725b8d$var$_refreshAll(true);
};
$8395061df1725b8d$export$875bcbe48555930.update = function(force) {
    return ++(0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).cache && $8395061df1725b8d$var$_updateAll(force === true ? 2 : 0);
};
$8395061df1725b8d$export$875bcbe48555930.clearScrollMemory = $8395061df1725b8d$var$_clearScrollMemory;
$8395061df1725b8d$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $8395061df1725b8d$var$_maxScroll(element, horizontal ? (0, $6f3f677ef5e7a33c$export$b2cabb342cb0ebe1) : (0, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d));
};
$8395061df1725b8d$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return (0, $6f3f677ef5e7a33c$export$8665aac53dad5647)((0, $6f3f677ef5e7a33c$export$937374fea3f88711)(element), horizontal ? (0, $6f3f677ef5e7a33c$export$b2cabb342cb0ebe1) : (0, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d));
};
$8395061df1725b8d$export$875bcbe48555930.getById = function(id) {
    return $8395061df1725b8d$var$_ids[id];
};
$8395061df1725b8d$export$875bcbe48555930.getAll = function() {
    return $8395061df1725b8d$var$_triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
$8395061df1725b8d$export$875bcbe48555930.isScrolling = function() {
    return !!$8395061df1725b8d$var$_lastScrollTime;
};
$8395061df1725b8d$export$875bcbe48555930.snapDirectional = $8395061df1725b8d$var$_snapDirectional;
$8395061df1725b8d$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $8395061df1725b8d$var$_listeners[type] || ($8395061df1725b8d$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$8395061df1725b8d$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $8395061df1725b8d$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$8395061df1725b8d$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $8395061df1725b8d$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $8395061df1725b8d$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($8395061df1725b8d$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $8395061df1725b8d$var$_addListener($8395061df1725b8d$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $8395061df1725b8d$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($8395061df1725b8d$export$875bcbe48555930.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var $8395061df1725b8d$var$_clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, $8395061df1725b8d$var$_allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, $6f3f677ef5e7a33c$export$c1cbdee04e18ea8b).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === $8395061df1725b8d$var$_docEl && _allowNativePanning($8395061df1725b8d$var$_body, direction);
}, $8395061df1725b8d$var$_overflow = {
    auto: 1,
    scroll: 1
}, $8395061df1725b8d$var$_nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || $8395061df1725b8d$var$gsap.core.getCache(node), time = $8395061df1725b8d$var$_getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== $8395061df1725b8d$var$_body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !($8395061df1725b8d$var$_overflow[(cs = $8395061df1725b8d$var$_getComputedStyle(node)).overflowY] || $8395061df1725b8d$var$_overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !$8395061df1725b8d$var$_isViewport(node) && ($8395061df1725b8d$var$_overflow[(cs = $8395061df1725b8d$var$_getComputedStyle(node)).overflowY] || $8395061df1725b8d$var$_overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
$8395061df1725b8d$var$_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, $6f3f677ef5e7a33c$export$c1cbdee04e18ea8b).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && $8395061df1725b8d$var$_nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && $8395061df1725b8d$var$_addListener($8395061df1725b8d$var$_doc, (0, $6f3f677ef5e7a33c$export$c1cbdee04e18ea8b).eventTypes[0], $8395061df1725b8d$var$_captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return $8395061df1725b8d$var$_removeListener($8395061df1725b8d$var$_doc, (0, $6f3f677ef5e7a33c$export$c1cbdee04e18ea8b).eventTypes[0], $8395061df1725b8d$var$_captureInputs, true);
        }
    });
}, $8395061df1725b8d$var$_inputExp = /(input|label|select|textarea)/i, $8395061df1725b8d$var$_inputIsFocused, $8395061df1725b8d$var$_captureInputs = function _captureInputs(e) {
    var isInput = $8395061df1725b8d$var$_inputExp.test(e.target.tagName);
    if (isInput || $8395061df1725b8d$var$_inputIsFocused) {
        e._gsapAllow = true;
        $8395061df1725b8d$var$_inputIsFocused = isInput;
    }
}, $8395061df1725b8d$var$_getScrollNormalizer = function _getScrollNormalizer(vars) {
    $8395061df1725b8d$var$_isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, $6f3f677ef5e7a33c$export$937374fea3f88711)(vars.target) || $8395061df1725b8d$var$_docEl, smoother = $8395061df1725b8d$var$gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = $8395061df1725b8d$var$_fixIOSBug && (vars.content && (0, $6f3f677ef5e7a33c$export$937374fea3f88711)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, $6f3f677ef5e7a33c$export$8665aac53dad5647)(target, (0, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d)), scrollFuncX = (0, $6f3f677ef5e7a33c$export$8665aac53dad5647)(target, (0, $6f3f677ef5e7a33c$export$b2cabb342cb0ebe1)), scale = 1, initialScale = ((0, $6f3f677ef5e7a33c$export$c1cbdee04e18ea8b).isTouch && $8395061df1725b8d$var$_win.visualViewport ? $8395061df1725b8d$var$_win.visualViewport.scale * $8395061df1725b8d$var$_win.visualViewport.width : $8395061df1725b8d$var$_win.outerWidth) / $8395061df1725b8d$var$_win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = $8395061df1725b8d$var$_isFunction(momentum) ? function() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = $8395061df1725b8d$var$_inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = $8395061df1725b8d$var$_passThrough, scrollClampY = $8395061df1725b8d$var$_passThrough, updateClamps = function updateClamps() {
        maxY = $8395061df1725b8d$var$_maxScroll(target, (0, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d));
        scrollClampY = $8395061df1725b8d$var$_clamp($8395061df1725b8d$var$_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = $8395061df1725b8d$var$_clamp(0, $8395061df1725b8d$var$_maxScroll(target, (0, $6f3f677ef5e7a33c$export$b2cabb342cb0ebe1))));
        lastRefreshID = $8395061df1725b8d$var$_refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = $8395061df1725b8d$var$_round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = $8395061df1725b8d$var$_round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = $8395061df1725b8d$var$_round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).cache;
                $8395061df1725b8d$var$_updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && $8395061df1725b8d$var$gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return $8395061df1725b8d$var$_fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = $8395061df1725b8d$var$_round(($8395061df1725b8d$var$_win.visualViewport && $8395061df1725b8d$var$_win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && $8395061df1725b8d$var$_allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = $8395061df1725b8d$var$_refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= $8395061df1725b8d$var$_clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, $8395061df1725b8d$var$_maxScroll(target, (0, $6f3f677ef5e7a33c$export$b2cabb342cb0ebe1)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= $8395061df1725b8d$var$_clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, $8395061df1725b8d$var$_maxScroll(target, (0, $6f3f677ef5e7a33c$export$8e40fc98ff518e9d)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if ($8395061df1725b8d$var$_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            $8395061df1725b8d$var$gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if ($8395061df1725b8d$var$_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = $8395061df1725b8d$var$_getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        $8395061df1725b8d$var$_refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && $8395061df1725b8d$var$_updateAll();
    };
    vars.onEnable = function() {
        $8395061df1725b8d$var$_allowNativePanning(target, normalizeScrollX ? false : "x");
        $8395061df1725b8d$export$875bcbe48555930.addEventListener("refresh", onResize);
        $8395061df1725b8d$var$_addListener($8395061df1725b8d$var$_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        $8395061df1725b8d$var$_allowNativePanning(target, true);
        $8395061df1725b8d$var$_removeListener($8395061df1725b8d$var$_win, "resize", onResize);
        $8395061df1725b8d$export$875bcbe48555930.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, $6f3f677ef5e7a33c$export$c1cbdee04e18ea8b)(vars);
    self.iOS = $8395061df1725b8d$var$_fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    $8395061df1725b8d$var$_fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    $8395061df1725b8d$var$_fixIOSBug && $8395061df1725b8d$var$gsap.ticker.add($8395061df1725b8d$var$_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = $8395061df1725b8d$var$gsap.to(self, {
        ease: "power4",
        paused: true,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: $8395061df1725b8d$var$_interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: $8395061df1725b8d$var$_updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
$8395061df1725b8d$export$875bcbe48555930.sort = function(func) {
    return $8395061df1725b8d$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + a.start - (b.start + (b.vars.refreshPriority || 0) * -1000000);
    });
};
$8395061df1725b8d$export$875bcbe48555930.observe = function(vars) {
    return new (0, $6f3f677ef5e7a33c$export$c1cbdee04e18ea8b)(vars);
};
$8395061df1725b8d$export$875bcbe48555930.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return $8395061df1725b8d$var$_normalizer;
    if (vars === true && $8395061df1725b8d$var$_normalizer) return $8395061df1725b8d$var$_normalizer.enable();
    if (vars === false) return $8395061df1725b8d$var$_normalizer && $8395061df1725b8d$var$_normalizer.kill();
    var normalizer = vars instanceof (0, $6f3f677ef5e7a33c$export$c1cbdee04e18ea8b) ? vars : $8395061df1725b8d$var$_getScrollNormalizer(vars);
    $8395061df1725b8d$var$_normalizer && $8395061df1725b8d$var$_normalizer.target === normalizer.target && $8395061df1725b8d$var$_normalizer.kill();
    $8395061df1725b8d$var$_isViewport(normalizer.target) && ($8395061df1725b8d$var$_normalizer = normalizer);
    return normalizer;
};
$8395061df1725b8d$export$875bcbe48555930.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, $6f3f677ef5e7a33c$export$5de019f4480f0f8d),
    _inputObserver: $8395061df1725b8d$var$_inputObserver,
    _scrollers: (0, $6f3f677ef5e7a33c$export$3cd1cee43d19b683),
    _proxies: (0, $6f3f677ef5e7a33c$export$d8e56d510a804d0a),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            $8395061df1725b8d$var$_lastScrollTime || $8395061df1725b8d$var$_dispatch("scrollStart");
            $8395061df1725b8d$var$_lastScrollTime = $8395061df1725b8d$var$_getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return $8395061df1725b8d$var$_refreshing;
        }
    }
};
$8395061df1725b8d$var$_getGSAP() && $8395061df1725b8d$var$gsap.registerPlugin($8395061df1725b8d$export$875bcbe48555930);


(0, $cab97051f2b305ae$export$99ee26438460406a).registerPlugin((0, $8395061df1725b8d$export$875bcbe48555930));
/**
 * Helper function that initializes animations on elements with the attribute 'ck-countup-element'
 */ const $499041b0c5868005$var$initAnimations = ()=>{
    // Selects all elements with the attribute 'ck-countup-element'
    document.querySelectorAll('[ck-countup-element]').forEach((element)=>{
        // The following lines get various configuration attributes or set defaults
        const startCount = Number(element.getAttribute('ck-countup-start'));
        const endCount = Number(element.getAttribute('ck-countup-end'));
        const snapValue = Number(element.getAttribute('ck-countup-snap'));
        const duration = Number(element.getAttribute('ck-countup-duration'));
        // Creates a timeline for the animation with a scroll trigger
        const tl = (0, $cab97051f2b305ae$export$99ee26438460406a).timeline({
            scrollTrigger: {
                trigger: element,
                start: 'top bottom',
                end: 'bottom top'
            }
        });
        /**
     * Updates innerHTML of number element with formatted variable
     */ const formatStat = ({ count: count }, target)=>{
            if (target.id === 'stat1') target.innerHTML = count.toFixed().toString() + '%';
            else if (target.id === 'stat2') target.innerHTML = '$' + count.toFixed().toString() + 'M';
            else if (target.id === 'stat3') target.innerHTML = count.toFixed() + 'x';
        };
        const state = {
            count: startCount
        };
        tl.fromTo(state, {
            count: startCount
        }, {
            count: endCount,
            duration: duration,
            ease: 'power2',
            snap: {
                count: snapValue
            },
            onUpdate: formatStat,
            onUpdateParams: [
                state,
                element
            ]
        });
    });
};
function $499041b0c5868005$export$2e2bcd8739ae039() {
    $499041b0c5868005$var$initAnimations();
}




(0, $cab97051f2b305ae$export$99ee26438460406a).registerPlugin((0, $8395061df1725b8d$export$875bcbe48555930));
function $9223f7c2d1c6da83$export$2e2bcd8739ae039() {
    window.ckAnimateReady = true;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[ck-animate]').forEach((element)=>{
        const transition = element.getAttribute('ck-animate');
        const delay = parseFloat(element.getAttribute('ck-animate-delay') || '0.325');
        // Release the CSS guard only once the tween is actually running and GSAP's inline opacity
        // is in place. Doing it any earlier lets the element show for a few frames, because
        // ScrollTrigger strips inline styles while it measures the page on its first refresh.
        const onStart = ()=>element.setAttribute('data-ck-animated', '');
        const tl = (0, $cab97051f2b305ae$export$99ee26438460406a).timeline({
            scrollTrigger: {
                trigger: element,
                start: 'top bottom',
                end: 'bottom top'
            }
        });
        if (transition === 'fadeUp') tl.fromTo(element, {
            opacity: 0,
            y: 30
        }, {
            opacity: 1,
            y: 0,
            duration: 1.2,
            delay: delay,
            ease: 'expo.out',
            onStart: onStart
        });
        else tl.fromTo(element, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 1.4,
            delay: delay,
            ease: 'expo.out',
            onStart: onStart
        });
    });
}


/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $93db36e58a847f3b$export$dfd9b671c89acc8e = 7;
const $93db36e58a847f3b$export$3913210603d8e9ae = 365.2425;
const $93db36e58a847f3b$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $93db36e58a847f3b$export$4dec998e48f9c246 = -$93db36e58a847f3b$export$81caae6e1cc7a622;
const $93db36e58a847f3b$export$4fad13613e88edc8 = 604800000;
const $93db36e58a847f3b$export$b76b1809a2898f9a = 86400000;
const $93db36e58a847f3b$export$91246f0b9bd9beff = 60000;
const $93db36e58a847f3b$export$7f72910d6dfd237a = 3600000;
const $93db36e58a847f3b$export$397c2d5776aa9055 = 1000;
const $93db36e58a847f3b$export$3633035e63cee86a = 525600;
const $93db36e58a847f3b$export$ab7da2ccd1075c38 = 43200;
const $93db36e58a847f3b$export$2423174df8cd3cd2 = 1440;
const $93db36e58a847f3b$export$f2f5ae5a8e2d8f9f = 60;
const $93db36e58a847f3b$export$3c58128db900d44e = 3;
const $93db36e58a847f3b$export$80d7e435f744f319 = 12;
const $93db36e58a847f3b$export$4db7641526e3241f = 4;
const $93db36e58a847f3b$export$698aec755e92c695 = 3600;
const $93db36e58a847f3b$export$a77c1a7ebebe2a5a = 60;
const $93db36e58a847f3b$export$815a9362476d2fe3 = $93db36e58a847f3b$export$698aec755e92c695 * 24;
const $93db36e58a847f3b$export$34804a017b31e2fe = $93db36e58a847f3b$export$815a9362476d2fe3 * 7;
const $93db36e58a847f3b$export$7271e9e3478110d1 = $93db36e58a847f3b$export$815a9362476d2fe3 * $93db36e58a847f3b$export$3913210603d8e9ae;
const $93db36e58a847f3b$export$8e6600bbdee7dabb = $93db36e58a847f3b$export$7271e9e3478110d1 / 12;
const $93db36e58a847f3b$export$be1dccf2de902d31 = $93db36e58a847f3b$export$8e6600bbdee7dabb * 3;
const $93db36e58a847f3b$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $e8361dcc50c395f7$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $93db36e58a847f3b$export$2a7b97929c48d47d) in date) return date[0, $93db36e58a847f3b$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$e8361dcc50c395f7$export$2e2bcd8739ae039 = $e8361dcc50c395f7$export$ead8a1812b171991;


function $a779267d9398e1be$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $e8361dcc50c395f7$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}



function $f08751f8d1b04ded$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $e8361dcc50c395f7$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$f08751f8d1b04ded$export$2e2bcd8739ae039 = $f08751f8d1b04ded$export$e67a095c620b86fe;


function $f6f3ee94bd9dcbce$export$fe114145ae75d197(dateLeft, dateRight) {
    const diff = +(0, $f08751f8d1b04ded$export$e67a095c620b86fe)(dateLeft) - +(0, $f08751f8d1b04ded$export$e67a095c620b86fe)(dateRight);
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$f6f3ee94bd9dcbce$export$2e2bcd8739ae039 = $f6f3ee94bd9dcbce$export$fe114145ae75d197;



function $b6f05b09d8b26cb7$export$c06dce8b38891685(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $a779267d9398e1be$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() - earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$b6f05b09d8b26cb7$export$2e2bcd8739ae039 = $b6f05b09d8b26cb7$export$c06dce8b38891685;


function $87720e04183ba9ea$export$ed6bf486f68899ca(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $a779267d9398e1be$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    // -1 if the left date is earlier than the right date
    // 2023-12-31 - 2024-01-01 = -1
    const sign = (0, $f6f3ee94bd9dcbce$export$fe114145ae75d197)(laterDate_, earlierDate_);
    // First calculate the difference in calendar years
    // 2024-01-01 - 2023-12-31 = 1 year
    const diff = Math.abs((0, $b6f05b09d8b26cb7$export$c06dce8b38891685)(laterDate_, earlierDate_));
    // Now we need to calculate if the difference is full. To do that we set
    // both dates to the same year and check if the both date's month and day
    // form a full year.
    laterDate_.setFullYear(1584);
    earlierDate_.setFullYear(1584);
    // For it to be true, when the later date is indeed later than the earlier date
    // (2026-02-01 - 2023-12-10 = 3 years), the difference is full if
    // the normalized later date is also later than the normalized earlier date.
    // In our example, 1584-02-01 is earlier than 1584-12-10, so the difference
    // is partial, hence we need to subtract 1 from the difference 3 - 1 = 2.
    const partial = (0, $f6f3ee94bd9dcbce$export$fe114145ae75d197)(laterDate_, earlierDate_) === -sign;
    const result = sign * (diff - +partial);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
var // Fallback for modularized imports:
$87720e04183ba9ea$export$2e2bcd8739ae039 = $87720e04183ba9ea$export$ed6bf486f68899ca;

const $f77cead40407099c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $f77cead40407099c$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $f77cead40407099c$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $2943e18bd47b5feb$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $b45fe55cf06d941e$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $b45fe55cf06d941e$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $b45fe55cf06d941e$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $b45fe55cf06d941e$export$cbf60ecb96cbb82f = {
    date: (0, $2943e18bd47b5feb$export$38e44e97ce4dbb7d)({
        formats: $b45fe55cf06d941e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $2943e18bd47b5feb$export$38e44e97ce4dbb7d)({
        formats: $b45fe55cf06d941e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $2943e18bd47b5feb$export$38e44e97ce4dbb7d)({
        formats: $b45fe55cf06d941e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $8cf0138fe6657a0a$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $8cf0138fe6657a0a$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$8cf0138fe6657a0a$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $26238257825b9911$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $9bb641a1aa9fc37f$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $9bb641a1aa9fc37f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $9bb641a1aa9fc37f$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $9bb641a1aa9fc37f$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $9bb641a1aa9fc37f$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $9bb641a1aa9fc37f$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $9bb641a1aa9fc37f$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $9bb641a1aa9fc37f$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $9bb641a1aa9fc37f$var$ordinalNumber,
    era: (0, $26238257825b9911$export$63596d6ee8878b25)({
        values: $9bb641a1aa9fc37f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $26238257825b9911$export$63596d6ee8878b25)({
        values: $9bb641a1aa9fc37f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $26238257825b9911$export$63596d6ee8878b25)({
        values: $9bb641a1aa9fc37f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $26238257825b9911$export$63596d6ee8878b25)({
        values: $9bb641a1aa9fc37f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $26238257825b9911$export$63596d6ee8878b25)({
        values: $9bb641a1aa9fc37f$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9bb641a1aa9fc37f$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $c41a7d25a1106f64$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $c41a7d25a1106f64$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $c41a7d25a1106f64$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c41a7d25a1106f64$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c41a7d25a1106f64$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $5bd8a9a15b8b8f76$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $d49089b5c3fc4f7b$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $d49089b5c3fc4f7b$var$parseOrdinalNumberPattern = /\d+/i;
const $d49089b5c3fc4f7b$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $d49089b5c3fc4f7b$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $d49089b5c3fc4f7b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $d49089b5c3fc4f7b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d49089b5c3fc4f7b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $d49089b5c3fc4f7b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $d49089b5c3fc4f7b$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $d49089b5c3fc4f7b$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $d49089b5c3fc4f7b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $d49089b5c3fc4f7b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $d49089b5c3fc4f7b$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $5bd8a9a15b8b8f76$export$fdaf2fd6d7edde95)({
        matchPattern: $d49089b5c3fc4f7b$var$matchOrdinalNumberPattern,
        parsePattern: $d49089b5c3fc4f7b$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c41a7d25a1106f64$export$1430a0f35710914d)({
        matchPatterns: $d49089b5c3fc4f7b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d49089b5c3fc4f7b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c41a7d25a1106f64$export$1430a0f35710914d)({
        matchPatterns: $d49089b5c3fc4f7b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d49089b5c3fc4f7b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c41a7d25a1106f64$export$1430a0f35710914d)({
        matchPatterns: $d49089b5c3fc4f7b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d49089b5c3fc4f7b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c41a7d25a1106f64$export$1430a0f35710914d)({
        matchPatterns: $d49089b5c3fc4f7b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d49089b5c3fc4f7b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c41a7d25a1106f64$export$1430a0f35710914d)({
        matchPatterns: $d49089b5c3fc4f7b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d49089b5c3fc4f7b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $850d2e5df397c2a2$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $f77cead40407099c$export$2c14ff85d6318973),
    formatLong: (0, $b45fe55cf06d941e$export$cbf60ecb96cbb82f),
    formatRelative: (0, $8cf0138fe6657a0a$export$8fbbfd65594f46a0),
    localize: (0, $9bb641a1aa9fc37f$export$b3bd0bc58e36cd63),
    match: (0, $d49089b5c3fc4f7b$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$850d2e5df397c2a2$export$2e2bcd8739ae039 = $850d2e5df397c2a2$export$137380d9ce54f7f;


let $f7fb887da5401bac$var$defaultOptions = {};
function $f7fb887da5401bac$export$430a3269e24b912e() {
    return $f7fb887da5401bac$var$defaultOptions;
}
function $f7fb887da5401bac$export$95365be1b0704abc(newOptions) {
    $f7fb887da5401bac$var$defaultOptions = newOptions;
}



function $285d411e557ee303$export$113002b5eff6e430(date) {
    const _date = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}





function $906670e8bffcf1fd$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$906670e8bffcf1fd$export$2e2bcd8739ae039 = $906670e8bffcf1fd$export$63fa379ae8a9ba2;


function $795c5916c7750cc1$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $a779267d9398e1be$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $906670e8bffcf1fd$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $906670e8bffcf1fd$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $285d411e557ee303$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $285d411e557ee303$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $93db36e58a847f3b$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$795c5916c7750cc1$export$2e2bcd8739ae039 = $795c5916c7750cc1$export$4a02e9c37dab4871;



function $604a805dcacc41a5$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$604a805dcacc41a5$export$2e2bcd8739ae039 = $604a805dcacc41a5$export$f91e89d3d0406102;



function $023fc42c67410e32$export$d3b42cd8452deec(date, options) {
    const _date = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $795c5916c7750cc1$export$4a02e9c37dab4871)(_date, (0, $604a805dcacc41a5$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$023fc42c67410e32$export$2e2bcd8739ae039 = $023fc42c67410e32$export$d3b42cd8452deec;





function $2bcf2786a1a5d5c8$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $f7fb887da5401bac$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$2bcf2786a1a5d5c8$export$2e2bcd8739ae039 = $2bcf2786a1a5d5c8$export$42c81a444fbfb5d4;


function $a025dcbdcc458b57$export$6173213f95a4431e(date, options) {
    return (0, $2bcf2786a1a5d5c8$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$a025dcbdcc458b57$export$2e2bcd8739ae039 = $a025dcbdcc458b57$export$6173213f95a4431e;






function $03edb3b303fe1294$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $e8361dcc50c395f7$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $a025dcbdcc458b57$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $e8361dcc50c395f7$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $a025dcbdcc458b57$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$03edb3b303fe1294$export$2e2bcd8739ae039 = $03edb3b303fe1294$export$3dbc52535f6f8fcc;



function $e064d58062a4444a$export$236bdfa374eb69a9(date, options) {
    const year = (0, $03edb3b303fe1294$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $e8361dcc50c395f7$export$ead8a1812b171991)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $a025dcbdcc458b57$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$e064d58062a4444a$export$2e2bcd8739ae039 = $e064d58062a4444a$export$236bdfa374eb69a9;



function $6a9840234f8a6572$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $a025dcbdcc458b57$export$6173213f95a4431e)(_date) - +(0, $e064d58062a4444a$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $93db36e58a847f3b$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$6a9840234f8a6572$export$2e2bcd8739ae039 = $6a9840234f8a6572$export$7cabdc5698b63e2f;











function $f5533040dd017e72$export$12d572480ceb6e58(date, options) {
    const _date = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $f7fb887da5401bac$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $e8361dcc50c395f7$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $2bcf2786a1a5d5c8$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $e8361dcc50c395f7$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $2bcf2786a1a5d5c8$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$f5533040dd017e72$export$2e2bcd8739ae039 = $f5533040dd017e72$export$12d572480ceb6e58;



function $e14d985bdf964a84$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $f7fb887da5401bac$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $f5533040dd017e72$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $e8361dcc50c395f7$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $2bcf2786a1a5d5c8$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$e14d985bdf964a84$export$2e2bcd8739ae039 = $e14d985bdf964a84$export$bb7b45bb8e74da0f;



function $3e0b3e9552f64c9e$export$efe19b760242b2fc(date, options) {
    const _date = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $2bcf2786a1a5d5c8$export$42c81a444fbfb5d4)(_date, options) - +(0, $e14d985bdf964a84$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $93db36e58a847f3b$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$3e0b3e9552f64c9e$export$2e2bcd8739ae039 = $3e0b3e9552f64c9e$export$efe19b760242b2fc;



function $ce0da1b2ae053f9c$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $7bd22298221657f7$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $894485c310dcfbd4$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $894485c310dcfbd4$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $7bd22298221657f7$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $f5533040dd017e72$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $03edb3b303fe1294$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $7bd22298221657f7$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $3e0b3e9552f64c9e$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $6a9840234f8a6572$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $7bd22298221657f7$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $023fc42c67410e32$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $894485c310dcfbd4$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $894485c310dcfbd4$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $894485c310dcfbd4$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $894485c310dcfbd4$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $894485c310dcfbd4$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $894485c310dcfbd4$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $7bd22298221657f7$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $7bd22298221657f7$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $7bd22298221657f7$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $7bd22298221657f7$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $7bd22298221657f7$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $894485c310dcfbd4$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $894485c310dcfbd4$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $894485c310dcfbd4$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $894485c310dcfbd4$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $894485c310dcfbd4$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $894485c310dcfbd4$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $894485c310dcfbd4$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $894485c310dcfbd4$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $894485c310dcfbd4$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $894485c310dcfbd4$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $894485c310dcfbd4$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(minutes, 2);
}
function $894485c310dcfbd4$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $894485c310dcfbd4$var$formatTimezone(offset, delimiter);
}
function $894485c310dcfbd4$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $ce0da1b2ae053f9c$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $524b57be887dc292$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $524b57be887dc292$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $524b57be887dc292$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $524b57be887dc292$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $524b57be887dc292$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $524b57be887dc292$var$timeLongFormatter(timePattern, formatLong));
};
const $524b57be887dc292$export$70cc8fd02856fd58 = {
    p: $524b57be887dc292$var$timeLongFormatter,
    P: $524b57be887dc292$var$dateTimeLongFormatter
};


const $83ff6d890611185a$var$dayOfYearTokenRE = /^D+$/;
const $83ff6d890611185a$var$weekYearTokenRE = /^Y+$/;
const $83ff6d890611185a$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $83ff6d890611185a$export$c6cc36aa33304772(token) {
    return $83ff6d890611185a$var$dayOfYearTokenRE.test(token);
}
function $83ff6d890611185a$export$c6b49d6dceb604a1(token) {
    return $83ff6d890611185a$var$weekYearTokenRE.test(token);
}
function $83ff6d890611185a$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $83ff6d890611185a$var$message(token, format, input);
    console.warn(_message);
    if ($83ff6d890611185a$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $83ff6d890611185a$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $8dd25242d31ee8f5$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$8dd25242d31ee8f5$export$2e2bcd8739ae039 = $8dd25242d31ee8f5$export$871608497c498473;



function $4c928ceb0c92b224$export$1ea939691cdc45b8(date) {
    return !(!(0, $8dd25242d31ee8f5$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$4c928ceb0c92b224$export$2e2bcd8739ae039 = $4c928ceb0c92b224$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $3e978256c0d6344f$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $3e978256c0d6344f$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $3e978256c0d6344f$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $3e978256c0d6344f$var$doubleQuoteRegExp = /''/g;
const $3e978256c0d6344f$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $3e978256c0d6344f$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $f7fb887da5401bac$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $850d2e5df397c2a2$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    if (!(0, $4c928ceb0c92b224$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($3e978256c0d6344f$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $524b57be887dc292$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($3e978256c0d6344f$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $3e978256c0d6344f$var$cleanEscapedString(substring)
        };
        if ((0, $894485c310dcfbd4$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($3e978256c0d6344f$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $83ff6d890611185a$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $83ff6d890611185a$export$c6cc36aa33304772)(token)) (0, $83ff6d890611185a$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $894485c310dcfbd4$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $3e978256c0d6344f$var$cleanEscapedString(input) {
    const matched = input.match($3e978256c0d6344f$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($3e978256c0d6344f$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$3e978256c0d6344f$export$2e2bcd8739ae039 = $3e978256c0d6344f$export$d9468344d3651243;










function $0eee1b4b1cd77717$export$489984ac7c996389(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $a779267d9398e1be$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
    return yearsDiff * 12 + monthsDiff;
}
var // Fallback for modularized imports:
$0eee1b4b1cd77717$export$2e2bcd8739ae039 = $0eee1b4b1cd77717$export$489984ac7c996389;



function $175b85c8c193435f$export$eb9a03f0e9aa6cea(date, options) {
    const _date = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$175b85c8c193435f$export$2e2bcd8739ae039 = $175b85c8c193435f$export$eb9a03f0e9aa6cea;



function $55de8fbeb1a4eb65$export$a2258d9c4118825c(date, options) {
    const _date = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$55de8fbeb1a4eb65$export$2e2bcd8739ae039 = $55de8fbeb1a4eb65$export$a2258d9c4118825c;



function $390d40ea9777fe79$export$c817d0312007ea5e(date, options) {
    const _date = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    return +(0, $175b85c8c193435f$export$eb9a03f0e9aa6cea)(_date, options) === +(0, $55de8fbeb1a4eb65$export$a2258d9c4118825c)(_date, options);
}
var // Fallback for modularized imports:
$390d40ea9777fe79$export$2e2bcd8739ae039 = $390d40ea9777fe79$export$c817d0312007ea5e;


function $ad80fb4577d723f4$export$fc1ed482c2861792(laterDate, earlierDate, options) {
    const [laterDate_, workingLaterDate, earlierDate_] = (0, $a779267d9398e1be$export$9f53b88e82f64d8d)(options?.in, laterDate, laterDate, earlierDate);
    const sign = (0, $f6f3ee94bd9dcbce$export$fe114145ae75d197)(workingLaterDate, earlierDate_);
    const difference = Math.abs((0, $0eee1b4b1cd77717$export$489984ac7c996389)(workingLaterDate, earlierDate_));
    if (difference < 1) return 0;
    if (workingLaterDate.getMonth() === 1 && workingLaterDate.getDate() > 27) workingLaterDate.setDate(30);
    workingLaterDate.setMonth(workingLaterDate.getMonth() - sign * difference);
    let isLastMonthNotFull = (0, $f6f3ee94bd9dcbce$export$fe114145ae75d197)(workingLaterDate, earlierDate_) === -sign;
    if ((0, $390d40ea9777fe79$export$c817d0312007ea5e)(laterDate_) && difference === 1 && (0, $f6f3ee94bd9dcbce$export$fe114145ae75d197)(laterDate_, earlierDate_) === 1) isLastMonthNotFull = false;
    const result = sign * (difference - +isLastMonthNotFull);
    return result === 0 ? 0 : result;
}
var // Fallback for modularized imports:
$ad80fb4577d723f4$export$2e2bcd8739ae039 = $ad80fb4577d723f4$export$fc1ed482c2861792;


function $e2672100afa1a701$export$b6474a47258c1211(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}



function $07cae1598a527927$export$7be94d13716b4bf6(laterDate, earlierDate) {
    return +(0, $f08751f8d1b04ded$export$e67a095c620b86fe)(laterDate) - +(0, $f08751f8d1b04ded$export$e67a095c620b86fe)(earlierDate);
}
var // Fallback for modularized imports:
$07cae1598a527927$export$2e2bcd8739ae039 = $07cae1598a527927$export$7be94d13716b4bf6;


function $f2b63678ae88e958$export$c1889aec51783710(laterDate, earlierDate, options) {
    const diff = (0, $07cae1598a527927$export$7be94d13716b4bf6)(laterDate, earlierDate) / 1000;
    return (0, $e2672100afa1a701$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$f2b63678ae88e958$export$2e2bcd8739ae039 = $f2b63678ae88e958$export$c1889aec51783710;


function $118b86307b433259$export$2c14ff85d6318973(laterDate, earlierDate, options) {
    const defaultOptions = (0, $f7fb887da5401bac$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $850d2e5df397c2a2$export$137380d9ce54f7f);
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $f6f3ee94bd9dcbce$export$fe114145ae75d197)(laterDate, earlierDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    const [laterDate_, earlierDate_] = (0, $a779267d9398e1be$export$9f53b88e82f64d8d)(options?.in, ...comparison > 0 ? [
        earlierDate,
        laterDate
    ] : [
        laterDate,
        earlierDate
    ]);
    const seconds = (0, $f2b63678ae88e958$export$c1889aec51783710)(earlierDate_, laterDate_);
    const offsetInSeconds = ((0, $285d411e557ee303$export$113002b5eff6e430)(earlierDate_) - (0, $285d411e557ee303$export$113002b5eff6e430)(laterDate_)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < (0, $93db36e58a847f3b$export$2423174df8cd3cd2)) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < (0, $93db36e58a847f3b$export$ab7da2ccd1075c38)) {
        const days = Math.round(minutes / (0, $93db36e58a847f3b$export$2423174df8cd3cd2));
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < (0, $93db36e58a847f3b$export$ab7da2ccd1075c38) * 2) {
        months = Math.round(minutes / (0, $93db36e58a847f3b$export$ab7da2ccd1075c38));
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $ad80fb4577d723f4$export$fc1ed482c2861792)(earlierDate_, laterDate_);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / (0, $93db36e58a847f3b$export$ab7da2ccd1075c38));
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}
var // Fallback for modularized imports:
$118b86307b433259$export$2e2bcd8739ae039 = $118b86307b433259$export$2c14ff85d6318973;



function $37b840b33bc4b18c$export$ea39ec197993aef0(laterDate, earlierDate, options) {
    const [dateLeft_, dateRight_] = (0, $a779267d9398e1be$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return +(0, $906670e8bffcf1fd$export$63fa379ae8a9ba2)(dateLeft_) === +(0, $906670e8bffcf1fd$export$63fa379ae8a9ba2)(dateRight_);
}
var // Fallback for modularized imports:
$37b840b33bc4b18c$export$2e2bcd8739ae039 = $37b840b33bc4b18c$export$ea39ec197993aef0;






function $4f5416ed9e8a2225$export$430a3269e24b912e() {
    return Object.assign({}, (0, $f7fb887da5401bac$export$430a3269e24b912e)());
}
var // Fallback for modularized imports:
$4f5416ed9e8a2225$export$2e2bcd8739ae039 = $4f5416ed9e8a2225$export$430a3269e24b912e;





function $5240561ab4c3eb87$export$9cb09a71b7d66923(date, constructor) {
    const date_ = $5240561ab4c3eb87$var$isConstructor(constructor) ? new constructor(0) : (0, $e8361dcc50c395f7$export$ead8a1812b171991)(constructor, 0);
    date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return date_;
}
function $5240561ab4c3eb87$var$isConstructor(constructor) {
    return typeof constructor === "function" && constructor.prototype?.constructor === constructor;
}
var // Fallback for modularized imports:
$5240561ab4c3eb87$export$2e2bcd8739ae039 = $5240561ab4c3eb87$export$9cb09a71b7d66923;


const $8c8928fea9139a1d$var$TIMEZONE_UNIT_PRIORITY = 10;
class $8c8928fea9139a1d$export$81d53e3678089a6 {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
class $8c8928fea9139a1d$export$9a09e32dd4990fd5 extends $8c8928fea9139a1d$export$81d53e3678089a6 {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
class $8c8928fea9139a1d$export$8be15fe85ad72f86 extends $8c8928fea9139a1d$export$81d53e3678089a6 {
    priority = $8c8928fea9139a1d$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    constructor(context, reference){
        super();
        this.context = context || ((date)=>(0, $e8361dcc50c395f7$export$ead8a1812b171991)(reference, date));
    }
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $e8361dcc50c395f7$export$ead8a1812b171991)(date, (0, $5240561ab4c3eb87$export$9cb09a71b7d66923)(date, this.context));
    }
}



class $25fcf50ce5b88ff4$export$7acfa6ed01010e37 {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, $8c8928fea9139a1d$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}


class $088a530805029f60$export$8e5a1d3f85a9688 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}




const $5ca2c213526e2f8d$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $5ca2c213526e2f8d$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $9359ca8138cd06c9$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $9359ca8138cd06c9$export$cc7cc9e2a3ff9388(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $9359ca8138cd06c9$export$6497f4c0ecdfba8e(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $93db36e58a847f3b$export$7f72910d6dfd237a) + minutes * (0, $93db36e58a847f3b$export$91246f0b9bd9beff) + seconds * (0, $93db36e58a847f3b$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $9359ca8138cd06c9$export$d931c43c4608a164(dateString) {
    return $9359ca8138cd06c9$export$cc7cc9e2a3ff9388((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $9359ca8138cd06c9$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $9359ca8138cd06c9$export$cc7cc9e2a3ff9388((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $9359ca8138cd06c9$export$cc7cc9e2a3ff9388((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $9359ca8138cd06c9$export$cc7cc9e2a3ff9388((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $9359ca8138cd06c9$export$cc7cc9e2a3ff9388((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $9359ca8138cd06c9$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $9359ca8138cd06c9$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $9359ca8138cd06c9$export$cc7cc9e2a3ff9388((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $9359ca8138cd06c9$export$cc7cc9e2a3ff9388((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $9359ca8138cd06c9$export$cc7cc9e2a3ff9388((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $9359ca8138cd06c9$export$cc7cc9e2a3ff9388((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $9359ca8138cd06c9$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $9359ca8138cd06c9$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $9359ca8138cd06c9$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $9359ca8138cd06c9$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


class $98e76fd5b6d711f0$export$48d352de7cd4a988 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)((0, $9359ca8138cd06c9$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)((0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $9359ca8138cd06c9$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}






class $7e47243098ac6e08$export$b8ef38dfcf05d5db extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)((0, $9359ca8138cd06c9$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)((0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $f5533040dd017e72$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $9359ca8138cd06c9$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $2bcf2786a1a5d5c8$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $2bcf2786a1a5d5c8$export$42c81a444fbfb5d4)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}






class $55c3799c5d037dca$export$951d1df011fde06f extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $9359ca8138cd06c9$export$2c9307b2e29c533c)(4, dateString);
        return (0, $9359ca8138cd06c9$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $e8361dcc50c395f7$export$ead8a1812b171991)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $a025dcbdcc458b57$export$6173213f95a4431e)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $08c8a4897ed99778$export$bad9d2ea38e8f1a extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $9359ca8138cd06c9$export$2c9307b2e29c533c)(4, dateString);
        return (0, $9359ca8138cd06c9$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $a4a9c7e11cb71c33$export$5cb0f701186dde1d extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $8de5b2263f475018$export$300c0c2990e20e6d extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $f63bc4b9de6e93e9$export$400dd8b40ef138a3 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)((0, $9359ca8138cd06c9$export$cc7cc9e2a3ff9388)((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)((0, $9359ca8138cd06c9$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}





class $d70f6ba9986590b3$export$1d7eaa53eaa5deba extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)((0, $9359ca8138cd06c9$export$cc7cc9e2a3ff9388)((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)((0, $9359ca8138cd06c9$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




function $d8aa22bddb62dd9f$export$4b3066ce4afafd88(date, week, options) {
    const date_ = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $3e0b3e9552f64c9e$export$efe19b760242b2fc)(date_, options) - week;
    date_.setDate(date_.getDate() - diff * 7);
    return (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date_, options?.in);
}
var // Fallback for modularized imports:
$d8aa22bddb62dd9f$export$2e2bcd8739ae039 = $d8aa22bddb62dd9f$export$4b3066ce4afafd88;






class $2569a62fc5d83366$export$c4005ffc174e07c0 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $9359ca8138cd06c9$export$cc7cc9e2a3ff9388)((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $2bcf2786a1a5d5c8$export$42c81a444fbfb5d4)((0, $d8aa22bddb62dd9f$export$4b3066ce4afafd88)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}




function $1fad8751786a271b$export$6542bebf6be94082(date, week, options) {
    const _date = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $6a9840234f8a6572$export$7cabdc5698b63e2f)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$1fad8751786a271b$export$2e2bcd8739ae039 = $1fad8751786a271b$export$6542bebf6be94082;






class $73b631e6cac0d415$export$6fc8dbedd560a6af extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $9359ca8138cd06c9$export$cc7cc9e2a3ff9388)((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $a025dcbdcc458b57$export$6173213f95a4431e)((0, $1fad8751786a271b$export$6542bebf6be94082)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}





const $338c880b1385a400$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $338c880b1385a400$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
class $338c880b1385a400$export$e8d4b28a20981dd2 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $9359ca8138cd06c9$export$cc7cc9e2a3ff9388)((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $9359ca8138cd06c9$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $338c880b1385a400$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $338c880b1385a400$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $cfb9caeffdd3b8b1$export$6cfe0d613455f615 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $9359ca8138cd06c9$export$cc7cc9e2a3ff9388)((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $9359ca8138cd06c9$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





function $8b3445c7425f2a6b$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $e8361dcc50c395f7$export$ead8a1812b171991)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$8b3445c7425f2a6b$export$2e2bcd8739ae039 = $8b3445c7425f2a6b$export$dd412b56f1e4d8aa;



function $643d4be73ebee814$export$b04fdcda82decc6c(date, day, options) {
    const defaultOptions = (0, $f7fb887da5401bac$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const date_ = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = date_.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $8b3445c7425f2a6b$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$643d4be73ebee814$export$2e2bcd8739ae039 = $643d4be73ebee814$export$b04fdcda82decc6c;



class $acca0bfdb09957eb$export$1b03c8b76262f7bd extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $643d4be73ebee814$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $bf8d0ff44f846fdd$export$44d1c127ab42c480 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)((0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $643d4be73ebee814$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}





class $78a11afadc8aed42$export$e447a647caaaec1d extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)((0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $643d4be73ebee814$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}




function $081f0e65fe681dfb$export$c514f4c1a8ed5e9e(date, options) {
    const day = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in).getDay();
    return day === 0 ? 7 : day;
}
var // Fallback for modularized imports:
$081f0e65fe681dfb$export$2e2bcd8739ae039 = $081f0e65fe681dfb$export$c514f4c1a8ed5e9e;



function $ea28ab301b41289b$export$1fd9df65adb0d1aa(date, day, options) {
    const date_ = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = (0, $081f0e65fe681dfb$export$c514f4c1a8ed5e9e)(date_, options);
    const diff = day - currentDay;
    return (0, $8b3445c7425f2a6b$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$ea28ab301b41289b$export$2e2bcd8739ae039 = $ea28ab301b41289b$export$1fd9df65adb0d1aa;




class $10951310eb0cd48d$export$693fb1e525095b2a extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $ea28ab301b41289b$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $e4089c8fe8b82ffc$export$8d1e08492351df91 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $9359ca8138cd06c9$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $802fb8b3d18493ca$export$73ca2bd0a17d273 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $9359ca8138cd06c9$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $5f3f58f1d1276b5c$export$bb9212adf05373db extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $9359ca8138cd06c9$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}





class $83e4e69acf1d11bf$export$8a04050a727a1756 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $9359ca8138cd06c9$export$cc7cc9e2a3ff9388)((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $3ccddab937db6da6$export$e56f4dea2c3e56dd extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $9359ca8138cd06c9$export$cc7cc9e2a3ff9388)((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $1ebd340cd74255cf$export$cbbe855312f87d77 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $9359ca8138cd06c9$export$cc7cc9e2a3ff9388)((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}





class $f91f5eccab0e04be$export$6008046d2b34b6a5 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $9359ca8138cd06c9$export$cc7cc9e2a3ff9388)((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}





class $d89760c9d9108504$export$2b52670d9e2be53 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $9359ca8138cd06c9$export$cc7cc9e2a3ff9388)((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}





class $561ba59d98b6e050$export$94d46d540cf1366a extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $9359ca8138cd06c9$export$cc7cc9e2a3ff9388)((0, $5ca2c213526e2f8d$export$c123ee06d9da8480).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}




class $815c5e86a35e0d21$export$b8e6f8b2d70893b1 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $9359ca8138cd06c9$export$4f84e3a82c7b538)((0, $9359ca8138cd06c9$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}







class $3115150d28cb595c$export$104d901d49fea29b extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $9359ca8138cd06c9$export$6497f4c0ecdfba8e)((0, $5ca2c213526e2f8d$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "XX":
                return (0, $9359ca8138cd06c9$export$6497f4c0ecdfba8e)((0, $5ca2c213526e2f8d$export$a7ee192b982af9c1).basic, dateString);
            case "XXXX":
                return (0, $9359ca8138cd06c9$export$6497f4c0ecdfba8e)((0, $5ca2c213526e2f8d$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $9359ca8138cd06c9$export$6497f4c0ecdfba8e)((0, $5ca2c213526e2f8d$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $9359ca8138cd06c9$export$6497f4c0ecdfba8e)((0, $5ca2c213526e2f8d$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $e8361dcc50c395f7$export$ead8a1812b171991)(date, date.getTime() - (0, $285d411e557ee303$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}







class $d0ccebf3fd25e0e2$export$12910e5204b52b9 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $9359ca8138cd06c9$export$6497f4c0ecdfba8e)((0, $5ca2c213526e2f8d$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "xx":
                return (0, $9359ca8138cd06c9$export$6497f4c0ecdfba8e)((0, $5ca2c213526e2f8d$export$a7ee192b982af9c1).basic, dateString);
            case "xxxx":
                return (0, $9359ca8138cd06c9$export$6497f4c0ecdfba8e)((0, $5ca2c213526e2f8d$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $9359ca8138cd06c9$export$6497f4c0ecdfba8e)((0, $5ca2c213526e2f8d$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $9359ca8138cd06c9$export$6497f4c0ecdfba8e)((0, $5ca2c213526e2f8d$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $e8361dcc50c395f7$export$ead8a1812b171991)(date, date.getTime() - (0, $285d411e557ee303$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}





class $e50373a4e1d7bacd$export$2cd8bf877a05e96 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 40;
    parse(dateString) {
        return (0, $9359ca8138cd06c9$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $e8361dcc50c395f7$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}





class $18215dd2217b8d3c$export$6d8f69c6906d6368 extends (0, $25fcf50ce5b88ff4$export$7acfa6ed01010e37) {
    priority = 20;
    parse(dateString) {
        return (0, $9359ca8138cd06c9$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $e8361dcc50c395f7$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}


const $0b1b3354df0866e1$export$19131010e7fd8373 = {
    G: new (0, $088a530805029f60$export$8e5a1d3f85a9688)(),
    y: new (0, $98e76fd5b6d711f0$export$48d352de7cd4a988)(),
    Y: new (0, $7e47243098ac6e08$export$b8ef38dfcf05d5db)(),
    R: new (0, $55c3799c5d037dca$export$951d1df011fde06f)(),
    u: new (0, $08c8a4897ed99778$export$bad9d2ea38e8f1a)(),
    Q: new (0, $a4a9c7e11cb71c33$export$5cb0f701186dde1d)(),
    q: new (0, $8de5b2263f475018$export$300c0c2990e20e6d)(),
    M: new (0, $f63bc4b9de6e93e9$export$400dd8b40ef138a3)(),
    L: new (0, $d70f6ba9986590b3$export$1d7eaa53eaa5deba)(),
    w: new (0, $2569a62fc5d83366$export$c4005ffc174e07c0)(),
    I: new (0, $73b631e6cac0d415$export$6fc8dbedd560a6af)(),
    d: new (0, $338c880b1385a400$export$e8d4b28a20981dd2)(),
    D: new (0, $cfb9caeffdd3b8b1$export$6cfe0d613455f615)(),
    E: new (0, $acca0bfdb09957eb$export$1b03c8b76262f7bd)(),
    e: new (0, $bf8d0ff44f846fdd$export$44d1c127ab42c480)(),
    c: new (0, $78a11afadc8aed42$export$e447a647caaaec1d)(),
    i: new (0, $10951310eb0cd48d$export$693fb1e525095b2a)(),
    a: new (0, $e4089c8fe8b82ffc$export$8d1e08492351df91)(),
    b: new (0, $802fb8b3d18493ca$export$73ca2bd0a17d273)(),
    B: new (0, $5f3f58f1d1276b5c$export$bb9212adf05373db)(),
    h: new (0, $83e4e69acf1d11bf$export$8a04050a727a1756)(),
    H: new (0, $3ccddab937db6da6$export$e56f4dea2c3e56dd)(),
    K: new (0, $1ebd340cd74255cf$export$cbbe855312f87d77)(),
    k: new (0, $f91f5eccab0e04be$export$6008046d2b34b6a5)(),
    m: new (0, $d89760c9d9108504$export$2b52670d9e2be53)(),
    s: new (0, $561ba59d98b6e050$export$94d46d540cf1366a)(),
    S: new (0, $815c5e86a35e0d21$export$b8e6f8b2d70893b1)(),
    X: new (0, $3115150d28cb595c$export$104d901d49fea29b)(),
    x: new (0, $d0ccebf3fd25e0e2$export$12910e5204b52b9)(),
    t: new (0, $e50373a4e1d7bacd$export$2cd8bf877a05e96)(),
    T: new (0, $18215dd2217b8d3c$export$6d8f69c6906d6368)()
};


/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $bdd296bdd2503ac0$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $bdd296bdd2503ac0$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $bdd296bdd2503ac0$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $bdd296bdd2503ac0$var$doubleQuoteRegExp = /''/g;
const $bdd296bdd2503ac0$var$notWhitespaceRegExp = /\S/;
const $bdd296bdd2503ac0$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $bdd296bdd2503ac0$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    const invalidDate = ()=>(0, $e8361dcc50c395f7$export$ead8a1812b171991)(options?.in || referenceDate, NaN);
    const defaultOptions = (0, $4f5416ed9e8a2225$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $850d2e5df397c2a2$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (!formatStr) return dateStr ? invalidDate() : (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(referenceDate, options?.in);
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will try to use the context or
    // the reference date and fallback to the system time zone.
    const setters = [
        new (0, $8c8928fea9139a1d$export$8be15fe85ad72f86)(options?.in, referenceDate)
    ];
    const tokens = formatStr.match($bdd296bdd2503ac0$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, $524b57be887dc292$export$70cc8fd02856fd58)) {
            const longFormatter = (0, $524b57be887dc292$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($bdd296bdd2503ac0$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $83ff6d890611185a$export$c6b49d6dceb604a1)(token)) (0, $83ff6d890611185a$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $83ff6d890611185a$export$c6cc36aa33304772)(token)) (0, $83ff6d890611185a$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, $0b1b3354df0866e1$export$19131010e7fd8373)[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return invalidDate();
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($bdd296bdd2503ac0$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $bdd296bdd2503ac0$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return invalidDate();
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $bdd296bdd2503ac0$var$notWhitespaceRegExp.test(dateStr)) return invalidDate();
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $f08751f8d1b04ded$export$e67a095c620b86fe)(referenceDate, options?.in);
    if (isNaN(+date)) return invalidDate();
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return invalidDate();
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return date;
}
function $bdd296bdd2503ac0$var$cleanEscapedString(input) {
    return input.match($bdd296bdd2503ac0$var$escapedStringRegExp)[1].replace($bdd296bdd2503ac0$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$bdd296bdd2503ac0$export$2e2bcd8739ae039 = $bdd296bdd2503ac0$export$98e6a39c04603d36;


/** Webflow site timezone (Site settings → General). Editors enter incident dates in this zone. */ const $690fe26e9084a0ad$export$16e8e76cd810cfc7 = 'America/New_York';
/** Editorial convention: an incident with no known time is entered as 1:00 pm Eastern. */ const $690fe26e9084a0ad$var$NO_TIME_PLACEHOLDER = {
    hour: 13,
    minute: 0
};
function $690fe26e9084a0ad$export$e86a0ecf0d50abeb(iso) {
    if (!iso) return false;
    const parsed = new Date(iso);
    if (Number.isNaN(parsed.getTime())) return false;
    if ($690fe26e9084a0ad$var$isMidnightUTC(parsed)) return false;
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: $690fe26e9084a0ad$export$16e8e76cd810cfc7,
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hourCycle: 'h23'
    }).formatToParts(parsed);
    const part = (type)=>Number(parts.find((p)=>p.type === type)?.value);
    const isPlaceholder = part('hour') === $690fe26e9084a0ad$var$NO_TIME_PLACEHOLDER.hour && part('minute') === $690fe26e9084a0ad$var$NO_TIME_PLACEHOLDER.minute && part('second') === 0 && parsed.getUTCMilliseconds() === 0;
    return !isPlaceholder;
}
function $690fe26e9084a0ad$var$isMidnightUTC(date) {
    return date.getUTCHours() === 0 && date.getUTCMinutes() === 0 && date.getUTCSeconds() === 0 && date.getUTCMilliseconds() === 0;
}
function $690fe26e9084a0ad$export$93522d1a439f3617(iso) {
    if (!iso) return null;
    const parsed = new Date(iso);
    if (Number.isNaN(parsed.getTime())) return null;
    if ($690fe26e9084a0ad$var$isMidnightUTC(parsed)) return new Date(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate());
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: $690fe26e9084a0ad$export$16e8e76cd810cfc7,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    }).formatToParts(parsed);
    const part = (type)=>Number(parts.find((p)=>p.type === type)?.value);
    return new Date(part('year'), part('month') - 1, part('day'));
}


const $073f23552e323dc4$export$202a481f622c4703 = 'Since Last Incident';
const $073f23552e323dc4$var$MINUTE = 60000;
const $073f23552e323dc4$var$HOUR = 60 * $073f23552e323dc4$var$MINUTE;
const $073f23552e323dc4$var$DAY = 24 * $073f23552e323dc4$var$HOUR;
function $073f23552e323dc4$export$9dcf773ab3ed161f({ iso: iso, dateString: dateString, suffix: suffix = 'ago', now: now = new Date() }) {
    const stamp = iso ? new Date(iso) : null;
    if (stamp && (0, $4c928ceb0c92b224$export$1ea939691cdc45b8)(stamp)) {
        const elapsed = now.getTime() - stamp.getTime();
        if (elapsed >= 0 && elapsed < $073f23552e323dc4$var$DAY) {
            if (elapsed < $073f23552e323dc4$var$HOUR) return `${$073f23552e323dc4$var$plural(Math.max(1, Math.floor(elapsed / $073f23552e323dc4$var$MINUTE)), 'minute')} ${suffix}`;
            return `${$073f23552e323dc4$var$plural(Math.floor(elapsed / $073f23552e323dc4$var$HOUR), 'hour')} ${suffix}`;
        }
    }
    const today = $073f23552e323dc4$var$onSiteClock(now);
    const day = dateString ? (0, $bdd296bdd2503ac0$export$98e6a39c04603d36)(dateString, 'MMMM dd, yyyy', today) : stamp && $073f23552e323dc4$var$onSiteClock(stamp);
    if (!day || !(0, $4c928ceb0c92b224$export$1ea939691cdc45b8)(day)) return null;
    // Same calendar day but no usable time (date-only entry, or a time later today):
    // hours counted from midnight would be invented precision.
    if ((0, $37b840b33bc4b18c$export$ea39ec197993aef0)(day, today) || day.getTime() > today.getTime()) return suffix === 'ago' ? 'Today' : `Less than a day ${suffix}`;
    if ((0, $87720e04183ba9ea$export$ed6bf486f68899ca)(today, day) >= 1) return (0, $3e978256c0d6344f$export$d9468344d3651243)(day, 'MMM d, yyyy');
    const distance = (0, $118b86307b433259$export$2c14ff85d6318973)(day, today).replace(/about |over |almost /g, '');
    return `${distance} ${suffix}`;
}
function $073f23552e323dc4$export$88ccf900a651cd29(iso, now = new Date()) {
    if (!iso) return false;
    const elapsed = now.getTime() - new Date(iso).getTime();
    return elapsed >= 0 && elapsed < $073f23552e323dc4$var$DAY;
}
/** The same instant, re-expressed so its local fields read as the site's wall clock. */ function $073f23552e323dc4$var$onSiteClock(date) {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: (0, $690fe26e9084a0ad$export$16e8e76cd810cfc7),
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hourCycle: 'h23'
    }).formatToParts(date);
    const get = (type)=>Number(parts.find((p)=>p.type === type)?.value);
    return new Date(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'), get('second'));
}
function $073f23552e323dc4$var$plural(count, unit) {
    return `${count} ${unit}${count === 1 ? '' : 's'}`;
}


const $4ab779b1bb2f4cf7$var$REFRESH_MS = 60000;
function $4ab779b1bb2f4cf7$export$2e2bcd8739ae039() {
    const targets = [
        ...[
            ...document.querySelectorAll('[ck-dayssince-spill]')
        ].map((element)=>({
                element: element
            })),
        ...[
            ...document.querySelectorAll('[ck-dayssince-ticker]')
        ].map((element)=>({
                element: element,
                suffix: (0, $073f23552e323dc4$export$202a481f622c4703)
            }))
    ];
    const render = ({ element: element, suffix: suffix })=>{
        const text = (0, $073f23552e323dc4$export$9dcf773ab3ed161f)({
            iso: element.getAttribute('ck-dayssince-iso'),
            dateString: element.getAttribute('ck-dayssince'),
            suffix: suffix
        });
        if (text && element.textContent !== text) element.textContent = text;
    };
    targets.forEach(render);
    // Only hour-level entries go stale quickly. The ticker duplicates its items after this runs,
    // so re-query it on each pass to keep the decorative copies in step.
    const recent = targets.filter(({ element: element })=>(0, $073f23552e323dc4$export$88ccf900a651cd29)(element.getAttribute('ck-dayssince-iso')));
    if (!recent.length) return;
    setInterval(()=>{
        recent.forEach(render);
        document.querySelectorAll('[ck-dayssince-ticker]').forEach((element)=>render({
                element: element,
                suffix: (0, $073f23552e323dc4$export$202a481f622c4703)
            }));
    }, $4ab779b1bb2f4cf7$var$REFRESH_MS);
}




(0, $cab97051f2b305ae$export$99ee26438460406a).registerPlugin((0, $8395061df1725b8d$export$875bcbe48555930));
function $ce0a5c67f3a0a175$export$2e2bcd8739ae039() {
    document.querySelectorAll('[ck-parallax').forEach((element)=>{
        const tl = (0, $cab97051f2b305ae$export$99ee26438460406a).timeline({
            scrollTrigger: {
                trigger: element,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true
            }
        });
        tl.fromTo(element, {
            y: 200
        }, {
            y: 0
        });
    });
}



/**
 * Moving focus from script without flashing a focus ring at touch and mouse users.
 *
 * The drawer has to move focus when it opens and closes, for keyboard and screen reader users.
 * Browsers decide for themselves whether a script-driven focus matches `:focus-visible`, and iOS
 * Safari says yes after a tap: taps never focus links or buttons there, so focus arrives "from
 * nowhere" and gets the ring. The Webflow focus styles are correct; the browser's guess is not.
 *
 * So we keep track of how the person last interacted. After a key press the ring is left alone.
 * After a pointer press the outline is switched off inline for as long as that element keeps
 * focus, and handed back to the stylesheet on blur, so a later Tab shows the ring as usual.
 */ let $11eca1529527b231$var$keyboard = false;
let $11eca1529527b231$var$listening = false;
function $11eca1529527b231$var$listen() {
    if ($11eca1529527b231$var$listening) return;
    $11eca1529527b231$var$listening = true;
    // Capture phase, so these run before any handler that goes on to move focus
    addEventListener('keydown', (event)=>{
        if (!event.metaKey && !event.ctrlKey && !event.altKey) $11eca1529527b231$var$keyboard = true;
    }, true);
    addEventListener('pointerdown', ()=>$11eca1529527b231$var$keyboard = false, true);
    addEventListener('touchstart', ()=>$11eca1529527b231$var$keyboard = false, {
        capture: true,
        passive: true
    });
}
function $11eca1529527b231$export$e60aa25de23972af() {
    $11eca1529527b231$var$listen();
}
function $11eca1529527b231$export$3c7398d50983b66d(element) {
    $11eca1529527b231$var$listen();
    if ($11eca1529527b231$var$keyboard) {
        element.focus();
        return;
    }
    const previous = element.style.outline;
    element.style.outline = 'none';
    element.addEventListener('blur', ()=>element.style.outline = previous, {
        once: true
    });
    element.focus();
}


const $7469e4063917f9da$var$DRAWER_DURATION = 0.45;
const $7469e4063917f9da$var$DRAWER_EASE = 'power3.out';
const $7469e4063917f9da$var$LINK_DURATION = 0.35;
const $7469e4063917f9da$var$LINK_STAGGER = 0.07;
const $7469e4063917f9da$var$LINK_OFFSET = 30;
const $7469e4063917f9da$var$SCROLL_DURATION = 0.3;
const $7469e4063917f9da$var$SCROLL_THRESHOLD = 80;
const $7469e4063917f9da$var$MOBILE_BREAKPOINT = 991;
function $7469e4063917f9da$export$2e2bcd8739ae039() {
    const navbar = document.querySelector('[ck-navbar]');
    if (!navbar) return;
    const btn = document.querySelector('[ck-navbar-btn]');
    const drawer = document.querySelector('[ck-navbar-drawer]');
    if (!btn || !drawer) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const durDrawer = reduced ? 0 : $7469e4063917f9da$var$DRAWER_DURATION;
    const durLink = reduced ? 0 : $7469e4063917f9da$var$LINK_DURATION;
    const stgLink = reduced ? 0 : $7469e4063917f9da$var$LINK_STAGGER;
    const durScroll = reduced ? 0 : $7469e4063917f9da$var$SCROLL_DURATION;
    // Everything beside the navbar goes inert while the drawer is open, except the share toast:
    // it has to stay announceable when the drawer's own Share button is used.
    const siblings = [
        ...navbar.parentElement.children
    ].filter((el)=>el !== navbar && el !== drawer && !el.hasAttribute('ck-share-toast'));
    const isMobile = ()=>window.innerWidth <= $7469e4063917f9da$var$MOBILE_BREAKPOINT;
    // Focus still moves into and out of the drawer for everyone, but only keyboard users see a ring
    (0, $11eca1529527b231$export$e60aa25de23972af)();
    // ── Sticky ticker ──
    // The ticker is always fixed to the top of the viewport. While the navbar is visible it sits
    // directly below it; when the navbar slides away on scroll-down the ticker slides up to take
    // its place, and comes back down together with the navbar on scroll-up.
    const ticker = document.querySelector('[ck-ticker]');
    const navHeight = ()=>navbar.offsetHeight;
    const placeTicker = ()=>{
        if (ticker) (0, $cab97051f2b305ae$export$99ee26438460406a).set(ticker, {
            top: navHeight()
        });
    };
    placeTicker();
    addEventListener('resize', placeTicker, {
        passive: true
    });
    document.fonts?.ready.then(placeTicker);
    const setNavVisible = (visible)=>{
        (0, $cab97051f2b305ae$export$99ee26438460406a).to(navbar, {
            y: visible ? 0 : '-100%',
            duration: durScroll,
            overwrite: true
        });
        if (ticker) (0, $cab97051f2b305ae$export$99ee26438460406a).to(ticker, {
            y: visible ? 0 : -navHeight(),
            duration: durScroll,
            overwrite: true
        });
    };
    // ── Drawer setup ──
    drawer.classList.remove('is-open');
    drawer.removeAttribute('data-state');
    (0, $cab97051f2b305ae$export$99ee26438460406a).set(drawer, {
        xPercent: 100,
        autoAlpha: 0
    });
    const links = drawer.querySelectorAll('[ck-navbar-link]');
    (0, $cab97051f2b305ae$export$99ee26438460406a).set(links, {
        x: $7469e4063917f9da$var$LINK_OFFSET,
        autoAlpha: 0
    });
    const tl = (0, $cab97051f2b305ae$export$99ee26438460406a).timeline({
        paused: true
    });
    tl.to(drawer, {
        xPercent: 0,
        autoAlpha: 1,
        duration: durDrawer,
        ease: $7469e4063917f9da$var$DRAWER_EASE
    }).to(links, {
        x: 0,
        autoAlpha: 1,
        duration: durLink,
        stagger: stgLink,
        ease: 'power2.out'
    }, '-=0.15');
    const focusable = ()=>[
            ...drawer.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])')
        ];
    const isOpen = ()=>btn.getAttribute('aria-expanded') === 'true';
    const open = ()=>{
        if (!isMobile()) return;
        btn.setAttribute('aria-expanded', 'true');
        drawer.setAttribute('aria-hidden', 'false');
        btn.textContent = 'Close';
        document.documentElement.classList.add('drawer-open');
        siblings.forEach((el)=>el.setAttribute('inert', ''));
        tl.restart();
        const items = focusable();
        if (items.length) tl.eventCallback('onComplete', ()=>{
            (0, $11eca1529527b231$export$3c7398d50983b66d)(items[0]);
            tl.eventCallback('onComplete', null);
        });
    };
    const close = (returnFocus = true)=>{
        btn.setAttribute('aria-expanded', 'false');
        drawer.setAttribute('aria-hidden', 'true');
        btn.textContent = 'Menu';
        document.documentElement.classList.remove('drawer-open');
        siblings.forEach((el)=>el.removeAttribute('inert'));
        tl.reverse();
        if (returnFocus) (0, $11eca1529527b231$export$3c7398d50983b66d)(btn);
    };
    // ── Drawer events ──
    btn.addEventListener('click', (e)=>{
        e.preventDefault();
        if (!isMobile()) return;
        isOpen() ? close() : open();
    });
    btn.addEventListener('keydown', (e)=>{
        if (e.key === ' ') {
            e.preventDefault();
            btn.click();
        }
    });
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && isOpen()) close();
    });
    document.addEventListener('click', (e)=>{
        if (!isOpen()) return;
        if (drawer.contains(e.target) || btn.contains(e.target)) return;
        close();
    });
    drawer.addEventListener('click', (e)=>{
        const link = e.target.closest('a[href]');
        if (!link || !isOpen()) return;
        // The Share button is an action, not navigation: keep the drawer open so its
        // "link copied" message shows up right where the tap happened.
        if (link.hasAttribute('ck-share')) return;
        const href = link.getAttribute('href');
        if (href?.startsWith('#')) {
            close(false);
            return;
        }
        try {
            const url = new URL(link.href, location.href);
            if (url.origin === location.origin && url.pathname === location.pathname) close(false);
        } catch  {}
    });
    document.addEventListener('keydown', (e)=>{
        if (e.key !== 'Tab' || !isOpen()) return;
        const ring = [
            btn,
            ...focusable()
        ];
        const i = ring.indexOf(document.activeElement);
        if (i < 0) return;
        if (e.shiftKey && i === 0) {
            e.preventDefault();
            ring[ring.length - 1].focus();
        } else if (!e.shiftKey && i === ring.length - 1) {
            e.preventDefault();
            ring[0].focus();
        }
    });
    window.addEventListener('resize', ()=>{
        if (!isMobile() && isOpen()) close(false);
    });
    // ── Scroll hide / show ──
    let lastY = scrollY;
    let raf = false;
    const tick = ()=>{
        const y = scrollY;
        if (!isOpen()) {
            if (y <= 0) setNavVisible(true);
            else if (y > lastY && y > $7469e4063917f9da$var$SCROLL_THRESHOLD) setNavVisible(false);
            else if (y < lastY) setNavVisible(true);
        }
        lastY = y;
        raf = false;
    };
    addEventListener('scroll', ()=>{
        if (!raf) {
            requestAnimationFrame(tick);
            raf = true;
        }
    }, {
        passive: true
    });
}


/**
 * Sticky marquee banner (`[ck-ticker]` in the Webflow Navbar component).
 *
 * The scroll itself is a CSS animation declared in the Navbar's custom-styles embed; this
 * module only prepares the DOM and manages the pause state:
 *
 * - duplicates the track's items once (aria-hidden) so the loop is seamless
 * - derives the animation duration from the content width so speed stays constant
 * - starts paused for `prefers-reduced-motion` users
 * - wires the Pause / Play toggle, which the CSS reveals on hover, focus, or while paused
 *
 * Positioning relative to the navbar lives in navScroll.ts, which owns the scroll state.
 */ const $e4ab711761f15ba2$var$SPEED_PX_PER_SECOND = 70;
const $e4ab711761f15ba2$var$MIN_DURATION_SECONDS = 20;
function $e4ab711761f15ba2$export$2e2bcd8739ae039() {
    const ticker = document.querySelector('[ck-ticker]');
    if (!ticker) return;
    const track = ticker.querySelector('[ck-ticker-track]');
    const toggle = ticker.querySelector('[ck-ticker-toggle]');
    if (!track) return;
    [
        ...track.children
    ].forEach((item)=>{
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, [tabindex]').forEach((el)=>{
            el.setAttribute('tabindex', '-1');
        });
        if (clone.matches('a, button')) clone.setAttribute('tabindex', '-1');
        track.appendChild(clone);
    });
    const setDuration = ()=>{
        const distance = track.scrollWidth / 2;
        const seconds = Math.max($e4ab711761f15ba2$var$MIN_DURATION_SECONDS, distance / $e4ab711761f15ba2$var$SPEED_PX_PER_SECOND);
        ticker.style.setProperty('--ticker-duration', `${seconds.toFixed(1)}s`);
    };
    setDuration();
    addEventListener('resize', setDuration, {
        passive: true
    });
    document.fonts?.ready.then(setDuration) // widths change once the web fonts land
    ;
    const setPaused = (paused, userChoice = false)=>{
        ticker.toggleAttribute('data-ck-paused', paused);
        // `data-ck-playing` lets an explicit Play override the reduced-motion default in CSS.
        ticker.toggleAttribute('data-ck-playing', userChoice && !paused);
        if (toggle) toggle.textContent = paused ? 'Play' : 'Pause';
    };
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    setPaused(reduced.matches);
    reduced.addEventListener?.('change', (e)=>setPaused(e.matches));
    if (!toggle) return;
    toggle.addEventListener('click', (e)=>{
        e.preventDefault();
        setPaused(!ticker.hasAttribute('data-ck-paused'), true);
    });
    // Webflow renders the toggle as a link with role="button"; give it native button keys.
    toggle.addEventListener('keydown', (e)=>{
        if (e.key === ' ' && toggle.tagName !== 'BUTTON') {
            e.preventDefault();
            toggle.click();
        }
    });
}


/** Pure helpers for the share buttons, kept DOM-light so they can be unit tested. */ function $e0b4eccf3b2e5169$export$3a81dd9bbf5c2322(location) {
    return `${location.origin}${location.pathname}`;
}
function $e0b4eccf3b2e5169$export$124e71d036a170cd({ canShare: canShare, coarsePointer: coarsePointer }) {
    return canShare && coarsePointer;
}


const $6d11c35bd83eade2$var$TOAST_MS = 2600;
const $6d11c35bd83eade2$var$GAP = 8 // px between the button and the message
;
const $6d11c35bd83eade2$var$EDGE = 8 // px kept clear of the viewport edge
;
const $6d11c35bd83eade2$var$COPIED_FALLBACK = 'Link copied to clipboard';
const $6d11c35bd83eade2$var$FAILED_FALLBACK = "Couldn\u2019t copy the link. Copy it from the address bar instead.";
function $6d11c35bd83eade2$export$2e2bcd8739ae039() {
    const buttons = document.querySelectorAll('[ck-share]');
    if (!buttons.length) return;
    const toast = document.querySelector('[ck-share-toast]');
    const copiedText = toast?.textContent?.trim() || $6d11c35bd83eade2$var$COPIED_FALLBACK;
    const failedText = toast?.getAttribute('ck-share-error') || $6d11c35bd83eade2$var$FAILED_FALLBACK;
    // A live region only announces changes, so it starts empty and is filled on demand.
    if (toast) toast.textContent = '';
    const anchored = toast?.getAttribute('ck-share-toast') === 'anchor';
    let hideTimer;
    let frame;
    const hide = ()=>{
        toast?.removeAttribute('data-ck-visible');
        if (frame) cancelAnimationFrame(frame);
        frame = undefined;
    };
    const announce = (message, button)=>{
        if (!toast) return;
        window.clearTimeout(hideTimer);
        if (frame) cancelAnimationFrame(frame);
        toast.textContent = message;
        if (anchored) {
            // Stay glued to the button for the couple of seconds the message is up, whether the page
            // scrolls or the button itself is still easing into place from an entrance animation.
            const follow = ()=>{
                $6d11c35bd83eade2$var$placeBeside(toast, button);
                frame = requestAnimationFrame(follow);
            };
            follow();
        }
        toast.setAttribute('data-ck-visible', '');
        hideTimer = window.setTimeout(hide, $6d11c35bd83eade2$var$TOAST_MS);
    };
    const share = async (button)=>{
        const url = (0, $e0b4eccf3b2e5169$export$3a81dd9bbf5c2322)(location);
        const native = (0, $e0b4eccf3b2e5169$export$124e71d036a170cd)({
            canShare: typeof navigator.share === 'function',
            coarsePointer: matchMedia('(pointer: coarse)').matches
        });
        if (native) try {
            await navigator.share({
                title: document.title,
                url: url
            });
            return;
        } catch (error) {
            // Closing the sheet is a choice, not a failure
            if (error?.name === 'AbortError') return;
        }
        announce(await $6d11c35bd83eade2$var$copy(url) ? copiedText : failedText, button);
    };
    buttons.forEach((button)=>{
        button.addEventListener('click', (event)=>{
            event.preventDefault();
            share(button);
        });
        // Webflow renders these as links with role="button"; give them native button keys.
        button.addEventListener('keydown', (event)=>{
            if (event.key === ' ' && button.tagName !== 'BUTTON') {
                event.preventDefault();
                button.click();
            }
        });
    });
}
/**
 * Pins the (position: fixed) toast just below the button, centred on it. Flips above when there
 * is no room underneath, and never lets it run off the side of the viewport.
 */ function $6d11c35bd83eade2$var$placeBeside(toast, button) {
    const target = button.getBoundingClientRect();
    const width = toast.offsetWidth;
    const height = toast.offsetHeight;
    const fitsBelow = target.bottom + $6d11c35bd83eade2$var$GAP + height <= innerHeight - $6d11c35bd83eade2$var$EDGE;
    const top = fitsBelow ? target.bottom + $6d11c35bd83eade2$var$GAP : target.top - $6d11c35bd83eade2$var$GAP - height;
    const centred = target.left + target.width / 2 - width / 2;
    const left = Math.min(Math.max(centred, $6d11c35bd83eade2$var$EDGE), Math.max($6d11c35bd83eade2$var$EDGE, innerWidth - width - $6d11c35bd83eade2$var$EDGE));
    Object.assign(toast.style, {
        top: `${Math.round(top)}px`,
        left: `${Math.round(left)}px`,
        right: 'auto',
        bottom: 'auto',
        margin: '0'
    });
}
async function $6d11c35bd83eade2$var$copy(text) {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch  {
    // permission denied or unavailable: try the legacy path below
    }
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none;';
    document.body.appendChild(field);
    field.select();
    let ok = false;
    try {
        ok = document.execCommand('copy');
    } catch  {
        ok = false;
    }
    field.remove();
    return ok;
}



/** Start fetching this far before the sentinel scrolls into view, so the rows are usually there. */ const $35185d42701a3fcc$var$LOOKAHEAD = '800px';
function $35185d42701a3fcc$export$2e2bcd8739ae039() {
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries)=>{
        for (const entry of entries){
            if (!entry.isIntersecting) continue;
            observer.unobserve(entry.target);
            load(entry.target);
        }
    }, {
        rootMargin: $35185d42701a3fcc$var$LOOKAHEAD
    });
    const watch = (root)=>{
        root.querySelectorAll('[ck-incidents-more]').forEach((el)=>observer.observe(el));
    };
    const load = async (sentinel)=>{
        const url = sentinel.getAttribute('ck-incidents-more');
        if (!url || sentinel.hasAttribute('data-ck-loading')) return;
        sentinel.setAttribute('data-ck-loading', '');
        try {
            const response = await fetch(url, {
                headers: {
                    accept: 'text/html'
                }
            });
            if (!response.ok) throw new Error(`${response.status} for ${url}`);
            const fragment = document.createRange().createContextualFragment(await response.text());
            const rows = [
                ...fragment.children
            ];
            sentinel.replaceWith(fragment);
            rows.forEach((row)=>(0, $e8de77a7e14f36ab$export$2e2bcd8739ae039)(row));
            const next = rows.find((row)=>row.matches('[ck-incidents-more]'));
            if (next) observer.observe(next);
        } catch (error) {
            console.error('Could not load more incidents', error);
            sentinel.removeAttribute('data-ck-loading');
            observer.observe(sentinel);
        }
    };
    watch(document);
}


console.info("%c\uD83D\uDD25CK Started!", 'color: red; font-size: 1rem;');
// accessibility enhancements
(0, $e8de77a7e14f36ab$export$2e2bcd8739ae039)();
(0, $15fdbb7456fb85b0$export$2e2bcd8739ae039)();
// Share buttons (copy link / native share sheet)
(0, $6d11c35bd83eade2$export$2e2bcd8739ae039)();
// Date Formatter
(0, $4ab779b1bb2f4cf7$export$2e2bcd8739ae039)();
// Home incident list: the rows past the first 200 arrive as the reader scrolls
(0, $35185d42701a3fcc$export$2e2bcd8739ae039)();
// gsap
(0, $499041b0c5868005$export$2e2bcd8739ae039)();
(0, $9223f7c2d1c6da83$export$2e2bcd8739ae039)();
(0, $ce0a5c67f3a0a175$export$2e2bcd8739ae039)();
(0, $7469e4063917f9da$export$2e2bcd8739ae039)();
(0, $e4ab711761f15ba2$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=index.js.map
